/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-04-29 17:34:54
 * @LastEditors: xst
 * @LastEditTime: 2020-07-10 11:34:15
 */
/**
 * Created by qjs on 2020/4/28.
 */
const api = {
  base:{
    transferAccount:'/deyt/base/transferAccount/pub/list',//报销单获取收款账户
    organizeTree:'/deyt/base/organization/tree',//获取组织架构的树形结构
    organizeList:'/deyt/base/organization/staff',//获取组织结构架构的人员列表
    organizeDing:'/deyt/base/organization/synchronize/ding',//同步钉钉
    mobileList: '/deyt/base/mobile/list', //所有app版本记录
    mobileDel: '/deyt/base/mobile/del', //删除版本
    mobileSave: '/deyt/base/mobile/save', //新建版本
    remList: '/deyt/base/remind/remList', //提醒列表
    remUpdate: '/deyt/base/remind/remUpdate', //更新提醒
    companyGroupList:'/deyt/base/pub/companyGroupList',//集团下的公司
    staffGroupList:'/deyt/base/pub/staffGroupList',//集团下的员工
    handoverCompanyList: 'deyt/base/pub/handoverCompanyList',
    handoverList: '/deyt/contract/pub/handoverList',// 交割点列表
    handoverDisable: '/deyt/base/handover/disable',// 禁用交割点
    handoverSave: '/deyt/base/handover/save',//交割点保存
    handoverUpdate: '/deyt/base/handover/update',// 交割点更新
    handoverListBase: '/deyt/base/handover/list', // 交割点列表
    updateInfo: '/deyt/base/account/updateInfo', // 重置密码
    websiteList:'/deyt/base/iot-site/list',//站点列表
    gaslist:'/deyt/base/gas/list',//气源地列表
    gasSave:'/deyt/base/gas/save',//新建气源地保存
    gasDetail:'/deyt/base/gas/detail',//气源地详情
    gasUpdate:'/deyt/base/gas/update',//气源地编辑保存
    siteState:'/deyt/base/pub/siteState',//站点运营状态
    useGasState:'/deyt/base/pub/useGasState',//站点用气状态
    siteType:'/deyt/base/pub/siteType',//站点类型
    containerType:'/deyt/base/pub/containerType',//容器类型
    savesite:'/deyt/base/iot-site/save',//新建保存
    companyList:'/deyt/base/pub/pc/companyList',//站点所属业务公司
    province:'/deyt/base/pub/province',//获取省
    city:'/deyt/base/pub/city',//获取市
    county:'/deyt/base/pub/county',//获取区
    getregin:'/deyt/base/pub/region',//获取省市区code，反向联动
    sitedetail:'/deyt/base/iot-site/detail',//站点详情
    updatesite:'/deyt/base/iot-site/update',//修改站点
    generatesite:"/deyt/base/iot-site/generate",//站点生成装卸地
    getsite:'/deyt/base/pub/site-list',//获取客户相应的站点
    getflowmeter:'/deyt/base/iot-device/findFlowmeter',//站点相应的流量计
    tagCompanyList: '/deyt/base/pub/pc/tagCompanyList',// 所有标签下的公司列表
    prodConfig: '/deyt/base/pub/prodConfig', // 产品供货方式配置的接口
    dictByCode: '/deyt/base/pub/dictByCode?code=sale_business_type', // 销售单业务类型
    sale_check_res_type: '/deyt/base/pub/dictByCode?code=sale_check_res_type', // 销售单核对类型
    ticketunit:'/deyt/base/pub/dictByCode?code=settle_ticket_unit',//新建开票的单位
    findByCustomer: '/deyt/base/iot-site/findByCustomer', // 站点列表
    generateOrderNo: '/deyt/base/global/generateOrderNo', // 生成单号
    invoice:'/deyt/base/company/invoice',//开票信息
    save_invoice:'/deyt/base/company/save-invoice',
    selectSupplyComp:'/deyt/base/companyAddInfo/selectSupplyComp', // 查询供气方公司信息
    listGroupStaff:'/deyt/base/pub/listGroupStaff', // 获取当前登录人集团下所有员工
    pubUpload:'/deyt/file/pubUpload', // 获取当前登录人集团下所有员工
    contractList:'/deyt/base/staff/data/contract/list', // 合同特权
    salesList:'/deyt/base/staff/data/sales/list', // 销售单特权
    meterList:'/deyt/base/staff/data/meter/list', // 销售计量单特权
    settlementList:'/deyt/base/staff/data/settlement/list', // 计量结算单特权
    adjustList:'/deyt/base/staff/data/adjust/list', // 调价函特权
    tsContractList:'/deyt/base/staff/data/ts-contract/list', // 运输合同特权
    tsTaskList:'/deyt/base/staff/data/ts-task/list', // 运输任务特权
    tsTransprotList:'/deyt/base/staff/data/ts-transprot/list', // 运输单特权
    tsCheckList:'/deyt/base/staff/data/ts-check/list', // 运输对量单特权
    tsBillList:'/deyt/base/staff/data/ts-bill/list', // 运输结算单特权
    cgContract:'/deyt/base/staff/data/buy-contract/list',//采购合同特权
    cgDocuments:'/deyt/base/staff/data/buy-documents/list',//采购单特权
    cgSettlement:'/deyt/base/staff/data/buy-settlement/list',//采购对账单特权
    staffList:'/deyt/base/pub/staffList', // 销售员列表
    handoverCompList:'/deyt/base/pub/handoverCompList', // 调价机制下拉表
    staffListByAccount:'/deyt/base/pub/staffListByAccount', // 人员下拉表
    detail:'/deyt/base/account/detail', // 编辑用户详情
    update:'/deyt/base/account/update', // 更新用户详情
    save:'/deyt/base/account/save', // 新增用户保存
    departList:'deyt/base/pub/departList', // 获取部门列表
    roleList:'/deyt/base/pub/roleList', // 获取角色列表
    companyState:'/deyt/base/pub/companyState', // 获取用户状态
    list:'/deyt/base/account/list', // 获取用户列表
    companyUpdate:'/deyt/base/company/update', // 更新公司
    companyAllList:'/deyt/base/company/list', // 公司列表
    companydisable:"/deyt/base/company/disable",//公司停用启用
    belongCompanyList:'/deyt/base/pub/belongCompanyList', // 公司列表
    parentCompanyList:'/deyt/base/pub/parentCompanyList', // 公司列表
    tagList:'/deyt/base/pub/tagList', // 获取标签列表
    companySave:'/deyt/base/company/save', // 保存公司
    departTree:'/deyt/base/depart/tree', // 部门数据
    departSave:'/deyt/base/depart/save', // 保存部门
    departDelete:'/deyt/base/depart/delete', // 删除部门
    departDatail:'/deyt/base/company/detail', // 部门详情
    assignPsm:'/deyt/base/role/assign-psm', // 授权保存
    treeRes:'/deyt/base/soft/tree-res', // 数据授权
    roleDetail:'/deyt/base/role/detail', // 角色详情
    roleUpdate:'/deyt/base/role/update', // 角色更新
    roleDisable:'/deyt/base/role/disable', // 删除角色
    roleSave:'/deyt/base/role/save', // 保存角色
    roleListAll:'/deyt/base/role/list', // 角色列表
    handleKeys:'/deyt/base/staff/data/handleKeys', // 处理选中key
    savePrivilege:'/deyt/base/staff/data/condition/savePrivilege', // 保存选择条件
    conditionList:'/deyt/base/staff/data/condition/list', // 人员数据特权信息
    staffDetail:'/deyt/base/staff/detail', // 人员详情
    staffDisable:'/deyt/base/staff/disable', // 人员禁用
    accountDisable:'/deyt/base/account/disable', // 账户禁用
    unlock:'/deyt/base/account/unlock', // 账户解锁
    staffUpdate:'/deyt/base/staff/update', // 人员更新
    staffSave:'/deyt/base/staff/save', // 人员新建
    staffRoleList:'deyt/base/pub//deyt/base/pub/roleList', // 角色数据
    staffListAll:'/deyt/base/staff/list', // 人员列表
    findFlowmeter:'/deyt/base/iotDevice/findFlowmeter', // 获取设备列表
    switchConfig:'/deyt/base/switchConfig/listByCompId', // 基础开关配置
    pubDictByCode:'/deyt/base/pub/dictByCode', // 基础字典表
    onOrOff:'/deyt/base/switchConfig/onOrOff', // 开启或关闭
    listActionByObjs:'/deyt/base/objAction/listActionByObjs', // 获取提醒人配置列表
    setDefaultRemindReceiver:'/deyt/base/objAction/setDefaultRemindReceiver', // 设置提醒人
    listByCompId:'/deyt/base/objAction/listByCompId', // 根据公司id获取默认提醒接收人
    listProdSupply:'/deyt/base/pub/listProdSupply', // 获取供货方式
    firstCompanyList:'/deyt/base/pub/firstCompanyList', // 获取供货方式
    listGas:'/deyt/base/pub/listGas', // 获取气源地列表
    listCompanyId:'/deyt/base/basePretend/listCompanyId', // 根据公司id查询所有的装卸地数据
    dataRoleList:'/deyt/base/baseDataRole/pageList', // 数据角色列表
    dataRoleSave:'/deyt/base/baseDataRole/save', // 数据角色新增保存
    dataRoleUpdate:'/deyt/base/baseDataRole/update', // 数据角色更新保存
    dataRoleDisable:'/deyt/base/baseDataRole/disable', // 数据角色启用禁用
    dataRoleDetail:'/deyt/base/baseDataRole/detail', // 数据角色详情
    dataRoleAssignAuth:'/deyt/base/baseDataRole/assignAuth', // 数据角色授权
    listFilterCondition:'/deyt/base/pub/listFilterCondition', // 获取筛选条件列表
    listFilterValue:'/deyt/base/pub/listFilterValue', // 获取筛选条件值的列表
    menuList:'/deyt/base/soft/menu-list', // 获取菜单列表
    listObject:'/deyt/base/pub/listObject', // 获取业务对象列表
    createAuthNode:'/deyt/base/baseDataRole/createAuthNode', // 创建权限节点
    deleteAuthNode:'/deyt/base/baseDataRole/deleteAuthNode', // 删除权限节点
    updateAuthNode:'/deyt/base/baseDataRole/updateAuthNode', // 更新权限节点
    treeAuthNode:'/deyt/base/baseDataRole/treeAuthNode', // 获取权限节点树
    authDetail:'/deyt/base/baseDataRole/authDetail', // 获取授权条件详情
    authCopy:'/deyt/base/baseDataRole/copy', // 复制角色
    listAll:'/deyt/base/baseDataRole/listAll', // 获取数据角色列表
    groupAllDepartList:'/deyt/base/pub/groupAllDepartList', // 获取集团部门列表
    checkAuth:'/deyt/base/baseDataRole/checkAuth', // 授权验证
    departListpub:'/deyt/base/pub/departList', // 公司下部门接口
    gasCompanyList:'/deyt/base/gas/gasCompanyList', // 气源地
    cylinderList:'/deyt/base/unloadDayCylinder/page',//钢瓶管理
    cylinderUnload:'/deyt/base/pub/unload',//钢瓶管理装卸地
    cylinderRush:'/deyt/base/unloadDayCylinder/dayStatistics',//钢瓶管理刷新
    siteIconType:'/deyt/base/pub/siteIconType',//图标类型

/*贸易 start*/
    customerList:'/deyt/base/trade/customerList', // 贸易客户列表
    tradeList:'/deyt/base/trade/list', // 贸易客户列表
    tradeUpdate:'/deyt/base/trade/update', // 更新
    tradeSave:'/deyt/base/trade/save', // 新增
    tradeInfo:'/deyt/base/trade/info', // 看板-贸易应收
    /*贸易 end*/
    basePretends:'/deyt/base/basePretend/listCompanyId', // 装卸地数据
    listAllRegion:'/deyt/base/basePretend/listAllRegion', // 根据公司id查询所有的装卸地数据带省市区
    provinceType:'/deyt/base/pub/provinceType', // 区域-省-模块赛选
    cityType:'/deyt/base/pub/cityType', //  区域-市-模块赛选
    countyType:'/deyt/base/pub/countyType', // 区域-区-模块赛选
    /*物联网二期 ： 标签管理 、 站点分组 start*/
    tagLists : '/deyt/base/tag/list', /*标签管理列表-无分页*/
    tagPageList: '/deyt/base/tag/page', /*标签管理列表-分页*/
    tagSave: '/deyt/base/tag/save', /*标签管理列表-新增*/
    tagUpdate: '/deyt/base/tag/update', /*标签管理列表-编辑*/
    tagInvalid: '/deyt/base/tag/invalid', /*标签管理列表-作废*/
    siteTagRel: '/deyt/base/tag/siteTagRel', /*站点 - 关联标签*/

    /*物联网二期 ： 标签管理 、 站点分组 start*/

    /*新版德运通挂牌价*/
    policyList:'/deyt/base/companyPricePolicy/findListByCondition',
    policyAddSave:'/deyt/base/companyPricePolicy/addSave',
    policyDetail:'/deyt/base/companyPricePolicy/detail',
    policyEditSave:'/deyt/base/companyPricePolicy/editSave',
    policyDelet:'/deyt/base/companyPricePolicy/delete',
    findCompanyListByPolicyType:'deyt/base/companyPricePolicy/findCompanyListByPolicyType',//根据政策类型查公司
    findRegionByCompany:'/deyt/base/companyPricePolicy/findRegionByCompany',

    /*LNG气化率*/
    baseGasificationLngPage:"/deyt/base/charge/baseGasificationLng/page",//列表
    baseGasificationLngSave:"/deyt/base/charge/baseGasificationLng/save",//新建
    baseGasificationLngUpdate:"/deyt/base/charge/baseGasificationLng/update",//更新
    baseGasificationLngDetail:"/deyt/base/charge/baseGasificationLng/detail",//详情
    baseGasificationLngDelete:"/deyt/base/charge/baseGasificationLng/delete",//删除
    baseGasificationLngStopState:"/deyt/base/charge/baseGasificationLng/stopState",//停用
    baseGasificationLngStopApproveState:"/deyt/base/charge/baseGasificationLng/approveState",//审批
    baseGasificationLngList:"/deyt/base/charge/baseGasificationLng/list",//列表
  },
  /*利润分析start*/
  profit:{
    changeprice:'/deyt/finance/unload/cost/adjustList',//批量改价
    costPage:'/deyt/finance/unload/cost/page',//交割点列表
    costView:'/deyt/finance/unload/cost/view',//交割点查看
    generateCost:'/deyt/finance/unload/cost/generate',//生成数据
    costExport:'/deyt/finance/unload/cost/export',//导出
    costApprove:'/deyt/finance/unload/cost/approve',//审批
    costAdjust:'/deyt/finance/unload/cost/adjust',//调整
    fixedAssetsList:'/deyt/finance/customer/asset/page',//固定资产列表
    fixedAssetsSave:'/deyt/finance/customer/asset/save',//固定资产新增
    fixedAssetsUpdate:'/deyt/finance/customer/asset/update',//固定资产更新
    fixedAssetsDetail:'/deyt/finance/customer/asset/detail',//固定资产详情
    fixedAssetsDelete:'/deyt/finance/customer/asset/delete',//固定资产删除
    fixedAssetsContract:'/deyt/finance/customer/asset/contract',//根据客户供气类型获取合同相关信息
    fixedAssetsExport:'/deyt/finance/customer/asset/export',//导出
    fixedLiquid:'/deyt/finance/customer/asset/update/liquid',//批量流转
    fixedAssetsCreate:'/deyt/finance/customer/asset/create',//固定资产生成数据

    analysisList:'/deyt/finance/cylinder/coefficient/page',//成本系数列表
    analysisUpdate:'/deyt/finance/cylinder/coefficient/update',//更新成本系数
    analysisView:'/deyt/finance/cylinder/coefficient/view',//成本系数详情
    analysisDelete:'/deyt/finance/cylinder/coefficient/delete',//成本系数删除
    analysisCreate:'/deyt/finance/cylinder/coefficient/create',//生成成本系数

    manageRateList:'/deyt/finance/manage/rate/page',//管理费率列表
    manageRateSave:'/deyt/finance/manage/rate/save',//管理费率新建
    manageRateUpdate:'/deyt/finance/manage/rate/update',//管理费率更新
    manageRateDetail:'/deyt/finance/manage/rate/detail',//管理费率详情
    manageRateDelete:'/deyt/finance/manage/rate/delete',//管理费率删除

    benefitsList:'/deyt/finance/profit/analysis/page',//利润分析列表
    getNew:'/deyt/finance/profit/analysis/customer',//获取新建利润分析数据
    benefitsSave:'/deyt/finance/profit/analysis/save',//新增保存
    benefitsUpdate:'/deyt/finance/profit/analysis/update',//编辑保存
    benefitsDetail:'/deyt/finance/profit/analysis/detail',//详情
    benefitsDelete:'/deyt/finance/profit/analysis/delete',//删除
    projectBenefits:'/deyt/finance/profit/analysis/project/page',//项目利润分析
    projectbtExport:'/deyt/finance/profit/analysis/project/export',//项目利润分析导出
    benefitExport:'/deyt/finance/profit/analysis/export',//利润分析导出
    benefitInport:'/deyt/finance/profit/analysis/updateBuyPrice',//利润分析批量更改成本

    orderExport:'/deyt/finance/profit/analysis/buyAmount/detailExport',//客户数据导出
    saleList:'/deyt/finance/profit/analysis/sale/list',//销售数据
    transportList:'/deyt/finance/profit/analysis/transport/list',//运输数据
    buyList:'/deyt/finance/profit/analysis/buyAmount/detail',//采购额明细数据
  },
/*利润分析end*/
  ding:{
    list:'/deyt/ding/ddCompanyProcessTask/listApproveProcess'
  },
  uaa: {
    resetPwd: "/deyt/uaa/oauth/resetPwd", // 找回密码
    token: "/deyt/uaa/oauth/token", // 登录
  },
  contract: {
    sellContractList:'/deyt/contract/sellContract/contTypeDictList',//获取合同的销售模式
    closingDate:'/deyt/finance/closing/companyClosingDate',//获取最后的关账日期
    customerList:"/deyt/contract/sellContract/customerList",//调价记录
    siteprice:"/deyt/contract/sellContract/site-price",//调价记录
    updatecharge:"/deyt/contract/sellContract/change-responsible",//更改负责人保存
    getapprovestate: "/deyt/contract/pub/adjustApproveState", //调价函审批状态
    getadjustState: "/deyt/contract/pub/adjustState", //调价函单据状态
    teplist: "/deyt/contract/template/list", //模板列表
    setDefault: "/deyt/contract/template/setDefault", //设置默认模板
    statisticsList: "/deyt/contract/sellContract/statisticsList",
    statisticsCount: "/deyt/contract/sellContract/statisticsCount",
    marketPriceCount: "/deyt/contract/market/price/count",
    checkLimit: "/deyt/contract/sellContract/checkLimit",
    deletcontract: "/deyt/contract/sellContract/delete", //删除合同
    deletremind: "/deyt/contract/remindSellCont/delete", //删除提醒
    detailremind: "/deyt/contract/remindSellCont/detail", //提醒详情
    updateremind: "/deyt/contract/remindSellCont/update", //编辑提醒
    saveremind: "/deyt/contract/remindSellCont/save", //新建提醒
    prodType: "/deyt/contract/pub/prodType", //获取产品类型
    linkSite: "/deyt/contract/sellContract/linkSite", //关联站点
    saveSite: "/deyt/contract/sellContract/saveSite", //关联站点保存
    getadjust: "/deyt/contract/settle-adjust/list", //调价函列表
    saveadjust: "/deyt/contract/settle-adjust/save", //保存调价函
    updateadjust: "/deyt/contract/settle-adjust/update", //修改保存调价函
    adjustdetail: "/deyt/contract/settle-adjust/detail", //调价函详情
    getcontsite: "/deyt/contract/settle-adjust/contSite", //客户试用站点
    getspecPrice: "/deyt/contract/settle-adjust/specPrice", //具体规格明细
    selectContPrice: "/deyt/contract/sellContract/selectContPrice", //获取合同计价信息
    cancel: "/deyt/contract/settle-adjust/invalid", //作废调价函
    approveadjust: "/deyt/contract/settle-adjust/approve", //审批调价函
    deletadjust: "/deyt/contract/settle-adjust/delete", //删除调价函
    adjustupfile:"/deyt/contract/settle-adjust/upload",//上传调价函附件
    getrecent: "/deyt/contract/settle-adjust/recent", //获取最近的调价信息
    pageList: "/deyt/contract/sellContLatestTerms/pageList", //获取最近的调价信息
    detail: "/deyt/contract/sellContLatestTerms/detail" ,//获取最近的调价信息
    invalidSave: "/deyt/contract/sellContract/invalid", //终止合同
    contState: "/deyt/contract/pub/contState", //获取合同签订状态
    contList: "/deyt/contract/sellContract/list", //获取合同列表
    unitListByTypes: "/deyt/contract/pub/unitListByTypes", //获取计量单位列表
    sellContractUpdate: "/deyt/contract/sellContract/update", //编辑合同保存
    getTemp: "/deyt/contract/template/getTemp", //获取单个合同模板
    getDetail: "/deyt/contract/sellContract/detail", //获取合同详情
    contTempList: "/deyt/contract/pub/contTempList", //获取合同模板列表
    contSave: "/deyt/contract/sellContract/save", //保存合同，
    contListPub: "/deyt/contract/pub/contList", //获取合同列表
    contListSelect: "/deyt/contract/pub/contList", //合同下拉
    contTempState: "/deyt/contract/pub/contTempState", //合同状态列表
    remindSellCont: "/deyt/contract/remindSellCont/pageList", //合同自定义提醒列表
    groupTodoList: "/deyt/contract/sellContTodo/groupTodoList", //我的合同列表
    ContTodoDetail: "/deyt/contract/sellContTodo/detail", //处理详情
    ContTodoUpdateStatus: "/deyt/contract/sellContTodo/updateStatus", //更新状态
    contBaseInfoList: "/deyt/contract/pub/contBaseInfoList", //查询合同基础信息
    selectLastSettleCycle: "/deyt/contract/sellContract/selectLastSettleCycle", //查询合同最近周期
    contStatistics: "/deyt/contract/sellContract/contStatistics", //合同统计
    tradeContractSave: "/deyt/contract/tradeContract/save", //贸易合同保存
    tradeContractUpdate: "/deyt/contract/tradeContract/update", //贸易合同编辑
    tradeContractDetail: "/deyt/contract/tradeContract/detail", //贸易合同详情
    tradeContractList: "/deyt/contract/tradeContract/list", //贸易合同列表
    tradeContractDelete: "/deyt/contract/tradeContract/delete", //贸易合同删除
    tradeContractInvalid: "/deyt/contract/tradeContract/invalid", //贸易合同作废
    tradeContractExecute: "/deyt/contract/tradeContract/execute", //贸易合同执行条款
    chargelist:"/deyt/contract/sellContract/terms/fee-list",//相关费用
    savecharge:"/deyt/contract/sellContract/terms/update-fee",//保存费用
    /*我的合同改版 20211129 start*/
    customTodoList:"/deyt/contract/sellContTodo/customTodoList",//自定义消息列表
    adjustPriceTodoList:"/deyt/contract/sellContTodo/adjustPriceTodoList",//需调价列表
    /*groupTodoList:"/deyt/contract/sellContTodo/groupTodoList",//自定义消息列表*/
    sellContractApprove:"/deyt/contract/sellContract/approve",//销售审批
    sellContractConfirmExecute:"/deyt/contract/sellContract/confirmExecute",//销售确认执行
    sellContractSupplementList:"/deyt/contract/sellContract/supplementList",//销售补充合同列表
    tradeContractApprove:"/deyt/contract/tradeContract/approve",//贸易审批
    tradeContractConfirmExecute:"/deyt/contract/tradeContract/confirmExecute",//贸易确认执行
    tradeContractSupplementList:"/deyt/contract/tradeContract/supplementList",//贸易补充合同列表
    /*我的合同改版 20211207 end*/
  },
  // 挂牌价
  dailyPrice:{
    pricelist:'/deyt/contract/market/price/list',//每日挂牌价
    beforeprice:'/deyt/contract/market/price/beforePrice',//价格
    savedaily:'/deyt/contract/market/price/save',//保存
    contSave: "/deyt/contract/sellContract/save", //保存合同
    contListPub: "/deyt/contract/pub/contList", //获取合同列表
  },
  sellSettle: {
    gasreceipt:"/deyt/sellSettle/meterOrder/gas-receipt",//生成气款
    meteradjust:"/deyt/sellSettle/meterOrder/adjust",//调差保存
    salePageList: "/deyt/sellSettle/sale/pageList", // 销售单列表
    orderPageList: "/deyt/sellSettle/meterOrder/orderPageList", // 销售计量单列表
    meterOrderDetail: "/deyt/sellSettle/meterOrder/detail", // 销售计量单详情
    saleSource: "/deyt/sellSettle/pub/saleSource", //  数据来源
    saleCheckStatus: "/deyt/sellSettle/pub/saleCheckStatus", //  内部核对状态
    saleSettleStatus: "/deyt/sellSettle/pub/saleSettleStatus", //  内部结算状态
    meterConfirmStatus: "/deyt/sellSettle/pub/meterConfirmStatus", //  确认状态
    save: "/deyt/sellSettle/sale/save", //  新增销售单
    detail: "/deyt/sellSettle/sale/detail", //  销售单详情
    update: "/deyt/sellSettle/sale/update", //  销售单更新
    invalid: "/deyt/sellSettle/sale/invalid", //  销售单作废
    check: "/deyt/sellSettle/sale/check", //  销售单核对
    selectLastSettleDate: "/deyt/sellSettle/settlement/selectLastSettleDate", //  查询最后结算周期截止日期
    sitePageList: "/deyt/sellSettle/sale/sitePageList", // 分页查询站点列表
    selectCustomerSale: "/deyt/sellSettle/meterOrder/selectCustomerSale", // 查询客户销售单列表
    meterOrderSave: "/deyt/sellSettle/meterOrder/save", // 销售计量单保存
    meterOrderUpdate: "/deyt/sellSettle/meterOrder/update", // 销售计量单更新
    customerStaffList: "/deyt/sellSettle/meterOrder/customerStaffList", // 客户接收方确认人列表
    meterOrderConfirm: "/deyt/sellSettle/meterOrder/confirm", // 计量单确认
    detailForPrint: "/deyt/sellSettle/meterOrder/detailForPrint", // 计量单打印详情
    weekStatistics: "/deyt/sellSettle/sale/weekStatistics", //  我的销售单--七日统计曲线
    meterStatistics: "/deyt/sellSettle/meterOrder/meterStatistics", //  我的销售单--计量单统计数据
    saleStatistics: "/deyt/sellSettle/sale/saleStatistics", //  我的销售单--销售单统计数据
    errSaleList: "/deyt/sellSettle/errSale/pageList", //  异常销售单
    importFinanceSale: "/deyt/sellSettle/errSale/reImportFinanceSale", //  重新异常销售单
    manualDeal: "/deyt/sellSettle/errSale/manualDeal", //  手动更新状态为处理完成
    preTicketPageList: "/deyt/sellSettle/invoice/preTicketPageList", //  待开票列表
    invoiceApprove: "/deyt/sellSettle/invoice/approve", //  发起审批接口
    invoiceCancel: "/deyt/sellSettle/ticket/invalid", //  取消发票
    meterOrderInvalid: "/deyt/sellSettle/meterOrder/invalid", //  计量单作废
    selectExecuteByCustomer: "/deyt/sellSettle/changeSupply/selectExecuteByCustomer", //  最新执行供货方式
    changeList: "/deyt/sellSettle/changeSupply/changeList", //  获取更改记录
    changeSupplySave: "/deyt/sellSettle/changeSupply/save", //  供货方式更改保存
    selectLastMeterEndDate: "/deyt/sellSettle/meterOrder/selectLastMeterEndDate", //  切换供货方式限制日期
    meterReadList:"/deyt/sellSettle/transcrib/site/page",//抄表客户列表
    flowNum:"/deyt/sellSettle/transcrib/site/flow-num",//获取开始结束读数
    updatemeter:"/deyt/sellSettle/transcrib/site/update-num",//修改读数
    saleListExport:'/deyt/sellSettle/sale/export',//销售单列表导出
   },
  settlment: {
    statistics: "/deyt/settlement/statistics", //结算单统计
    reconciliation: "/deyt/settlement/reconciliation", //待对账
    cumulative: "/deyt /settlement/cumulative", //昨日累计结算额
    pageList: "/deyt/sellSettle/settlement/pageList", //结算单列表
    details: "/deyt/settlement/details", //结算单详情
    listAvgMoney: "/deyt/sellSettle/settlement/listAvgMoney", //结算单日平均价
    abnormal: "/deyt/settlement/abnormal", //异常结算单
    update: "/deyt/settlement/update", //结算单对账
    printingBottle: "/deyt/settlement/printingBottle", //结算单对账模板（钢瓶组）
    flow: "/deyt/settlement/flow", //结算单对账模板（流量计）
    printingWeight: "/deyt/settlement/printingWeight", //结算单对账模板（重量）
    closeAccount: "/deyt/settlement/closeAccount", //结算单关账列表
    accountDetailed: "/deyt/settlement/accountDetailed", //结算单关账明细(已关帐)
    accountNoDetailed: "/deyt/settlement/accountNoDetailed", //结算单关账明细(未关帐)
    clause: "/deyt/settlement/clause", //结算单关账明细(未关帐)
    statementToVoid: "/deyt/sellSettle/settlement/statementToVoid", //作废
    statementToVoidDel: "/deyt/sellSettle/settlement/statementToVoidDel", //删除
    //getinvoice: "/deyt/sellSettle/invoice/list", //销售开票列表
    getinvoice: "/deyt/finance/invoice/list", //销售开票列表
    getsettlelist: "/deyt/sellSettle/invoice/settle-list", //选择结算单
    confirmsettle: "/deyt/sellSettle/invoice/confirm", //确认开票
    settletype: "/deyt/base/pub/dictByCode?code=settle_ticket_item", //选择销售开票名称
    //saveinvoice: "/deyt/sellSettle/invoice/save", //新建销售开票保存
    saveinvoice: "/deyt/finance/invoice/save", //新建销售开票保存
    //updateinvoice: "/deyt/sellSettle/invoice/update", //编辑销售开票
    updateinvoice: "/deyt/finance/invoice/update", //编辑销售开票
    //invoicedetai: "/deyt/sellSettle/invoice/detail", //销售开票详情
    invoicedetai: "/deyt/finance/invoice/detail", //销售开票详情
    //settleinvalid: "/deyt/sellSettle/invoice/invalid", //作废销售开票
    settleinvalid: "/deyt/finance/invoice/invalid", //作废销售开票
    //deletsettle: "/deyt/sellSettle/invoice/delete", //删除销售开票
    deletsettle: "/deyt/finance/invoice/delete", //删除销售开票
    getinvoiceState: "/deyt/sellSettle/pub/invoiceState", //开票状态
    getticket: "/deyt/sellSettle/ticket/list", //开票列表
    ticketdetail: "/deyt/sellSettle/ticket/detail", //开票详情
    ticketexport:'/deyt/sellSettle/ticket/export',//导出开票
    newAddList: "/deyt/sellSettle/settlement/newAddList", //新建结算单详情
    statementSave: "/deyt/sellSettle/settlement/statementSave", //新建结算单保存
    statementUpdate:"/deyt/sellSettle/settlement/update",//编辑结算单保存
    listDetailMoney: "/deyt/sellSettle/settlement/listDetailMoney", //根据计量单id返回销售单数据
    listSellSettle: "/deyt/sellSettle/settlement/listSellSettle", //根据结算id查询计量单数据
    resultSellDetail: "/deyt/sellSettle/settlement/resultSellDetail", //根据结算单id获取详情数据
    resultTradeDetail:'/deyt/trade/tradeStatementOrder/invoice/view',//贸易的开票详情
    saveAccountStatement: "/deyt/sellSettle/settlement/saveAccountStatement", //保存对账详情
    listDetailResult: "/deyt/sellSettle/settlement/listDetailResult", // 根据结算id返回每天销售单
    listMoneyConfig: "/deyt/sellSettle/settlement/listMoneyConfig", // 返回配置表信息
    listMeterAbnormal: "/deyt/sellSettle/abl/listMeterAbnormal", // 返回异常数据
    pageListAbnormal: "/deyt/sellSettle/abl/pageListAbnormal", // 返回分页异常数据
    listMeterAbnormalSelf: "/deyt/sellSettle/abl/listMeterAbnormalSelf", // 自检操作
    SaleDateAbnormalList: "/deyt/sellSettle/abl/SaleDateAbnormalList", //异常计量单- 根据异常单返回销售单 - 列表
    saveAbnormal: "/deyt/sellSettle/abl/saveAbnormal", //异常计量单- 异常保存带价格销售单
    /*postPricingResult: "/deyt/sellSettle/settlement/postPricingResult", //后定价更改结算金额*/
    listMyNumLine: "/deyt/sellSettle/settlement/listMyNumLine", //折线图
    sellPie: "/deyt/sellSettle/settlement/sellPie", //饼状图
    sellMuNum: "/deyt/sellSettle/settlement/sellMuNum", //我的结算单
    listMyNumProd: "/deyt/sellSettle/settlement/listMyNumProd", //统计我的结果 产品
    page: "/deyt/sellSettle/sellSettleCloseAccount/page", //关账列表
    closedetail: "/deyt/sellSettle/sellSettleCloseAccount/detail", //关账详情
    close: "/deyt/sellSettle/sellSettleCloseAccount/close", //关账
    check: "/deyt/sellSettle/sellSettleCloseAccount/check" ,//关账检查
    sellDetailExcel: "/deyt/sellSettle/settlement/export", //导出 结算单列表ecxel
    sellDetailPrinting: "/deyt/sellSettle/settlement/sellDetailPrinting", //打印 模板 数据
    exportAbl: "/deyt/sellSettle/abl/export", //异常单导出xls 打印 模板 数据
    exportSSA: "/deyt/sellSettle/sellSettleCloseAccount/export", //异常单导出xls 打印 模板 数据
    //字典
    invoiceStateProducts: "/deyt/sellSettle/pub/invoiceStateProducts", //结算单产品
    invoiceStatePrice: "/deyt/sellSettle/pub/invoiceStatePrice", //结算 是否调价
    invoiceStateState: "/deyt/sellSettle/pub/invoiceStateState", //结算 结算状态
    invoiceStateVoid: "/deyt/sellSettle/pub/invoiceStateVoid", //结算 是否作废
    meterConfirmStatus: "/deyt/sellSettle/pub/meterConfirmStatus", //结算 确认状态
    adjustprint:"/deyt/contract/settle-adjust/print",//调价函打印

    sellSettlementPriceList:"/deyt/sellSettle/settlement/sellSettlementPriceList",//后定价获取详情
    postPricingResult:"/deyt/sellSettle/settlement/postPricingResult",//后定价更改结算金额
    sellSettlementOtherDel:"/deyt/sellSettle/settlement/sellSettlementOtherDel",//后定价更改结算金额
    errOrderList:"/deyt/sellSettle/errOrder/pageList",//异常单据列表
    errOrderManualDeal:"/deyt/sellSettle/errOrder/manualDeal",//手动更新异常单据状态
    updateTicket:"/deyt/sellSettle/ticket/update",//发票编辑
    detailForMergePrint:"/deyt/sellSettle/settlement/detailForMergePrint",//全部打印
    settleOtherFee:"/deyt/sellSettle/settleOtherFee/pageList",//其他费用列表
    settleOtherFeeSave:"/deyt/sellSettle/settleOtherFee/save",//其他费用保存
    settleOtherFeeUpdate:"/deyt/sellSettle/settleOtherFee/update",//其他费用更新
    settleOtherFeeInvalid:"/deyt/sellSettle/settleOtherFee/invalid",//其他费用作废
    settleOtherFeeDetail:"/deyt/sellSettle/settleOtherFee/detail",//其他费用详情
    settleOtherFeeDelete:"/deyt/sellSettle/settleOtherFee/delete",//其他费用删除
    settleOtherFeeConfirm:"/deyt/sellSettle/settleOtherFee/confirm",//其他费用确认
    settleOtherFeeApprove:"/deyt/sellSettle/settleOtherFee/approve",//其他费用审批
    listTicket:"/deyt/sellSettle/ticket/listTicket",//其他费用审批
    getCusAbsolveRent:"/deyt/sellSettle/settlement/getCusAbsolveRent",//获取租赁费剩余可免除次数

    receivabletype:"/deyt/sellSettle/pub/receipt-type",//收款项类型
    receivableList:"/deyt/sellSettle/sell/settleReceipt/page",//收款项列表
    receivableSave:"/deyt/sellSettle/sell/settleReceipt/save",//收款项保存
    receivableUpdate:"/deyt/sellSettle/sell/settleReceipt/update",//收款项更新
    receivableInvalid:"/deyt/sellSettle/sell/settleReceipt/invalid",//收款项作废
    receivableDetail:"/deyt/sellSettle/sell/settleReceipt/detail",//收款项详情
    receivableDelete:"/deyt/sellSettle/sell/settleReceipt/delete",//收款项删除
    receivableConfirm:"/deyt/sellSettle/sell/settleReceipt/confirm",//收款项确认
    receivableApprove:"/deyt/sellSettle/sell/settleReceipt/approve",//收款项审批
    receivableAdjustprice:"/deyt/sellSettle/sell/settleReceipt/adjust-price",//收款项调整价格
    receivableSaveprice:"/deyt/sellSettle/sell/settleReceipt/save-price",//收款项保存价格
    receivableGasdetail:"/deyt/sellSettle/sell/settleReceipt/gas-detail",//收款项气款明细
    receivableRentderate:"/deyt/sellSettle/sell/settleReceipt/rent-derate",//收款项合同租金可减免次数
    saveFileList:"/deyt/sellSettle/settlement/saveFileList",//上传附件保存
    /*新增 欠费申请*/
    applyList:"/deyt/buy/buy/apply/list",//列表
    applyPageList:"/deyt/buy/buy/apply/page",//列表分页
    applyDetail:"/deyt/buy/buy/apply/detail",//详情
    applyDelete:"/deyt/buy/buy/apply/delete",//删除
    applyApprove:"/deyt/buy/buy/apply/approve",//审批
    applySave:"/deyt/buy/buy/apply/save",//保存
    applyUpdate:"/deyt/buy/buy/apply/update",//编辑

  },
  innerCash:{
    innerpriceList:"/deyt/buy/insideListingPrice/list",//内部挂牌价

    groupInputTemPage:"/deyt/buy/groupInputTem/page",//集团采购列表
    groupInputTemSave:"/deyt/buy/groupInputTem/save",//新建集团采购
    groupInputTemUpdate:"/deyt/buy/groupInputTem/update",//更新集团采购
    groupInputTemDetail:"/deyt/buy/groupInputTem/detail",//集团采购详情
    groupInputTemDelete:"/deyt/buy/groupInputTem/delete",//集团采购删除
    groupInputTemGasCompany:"/deyt/buy/groupInputTem/gasCompany",//获取益广，平庄，金鸿公司信息

    gascompany:"/deyt/buy/pub/gasCompany",//获取益广，平庄，金鸿公司信息
    groupList:"/deyt/buy/groupInputTem/list",//集团采购列表
    savegroup:"/deyt/buy/groupInputTem/save",//新建集团采购
    detailgroup:"/deyt/buy/groupInputTem/detail",//集团采购详情
    updategroup:"/deyt/buy/groupInputTem/update",//更新集团采购
    relatelist:"/deyt/buy/groupInputTem/listAll",//关联列表
    relation:"/deyt/buy/groupInputTem/relation",//关联保存
    relationdel:"/deyt/buy/groupInputTem/listRelationDel",//关联删除
    deletegroup:"/deyt/buy/groupInputTem/del",//删除集团采购

    priceList:"/deyt/buy/insidePrice/page",//内部挂牌价历史 列表    -- 结算单价列表
    inneravgMoney:"/deyt/buy/insidePrice/avgMoney",//内部挂牌价历史 -- 气源平均单价 -- 平均单价
    listRecord:"/deyt/buy/insidePrice/listRecord",//平均运费

    innerformList:"/deyt/buy/internalSettlement/list",//结算表格
    innerformdetail:"/deyt/buy/internalSettlement/detail",//结算详情

    compareform:"/deyt/buy/summary/list",//结算对比表

    fixedList:"/deyt/buy/feightMoney/list",//固定运费列表
    fixedeffect:"/deyt/buy/feightMoney/effective",//运费生效
    savaJob:"/deyt/buy/feightMoney/saveJob",//job执行

    rejectList:"/deyt/buy/supplyGas/list",//剔除列表
    rejectdetail:"/deyt/buy/supplyGas/detail",//剔除详情
    rejectsave:"/deyt/buy/supplyGas/save",//剔除新建保存
    rejectupdate:"/deyt/buy/supplyGas/update",//剔除编辑保存
    rejectdel:"/deyt/buy/supplyGas/del",//剔除信息删除
    codeGas:'/deyt/base/gas/codeGas', // 获取气源地列表
    benchmarkList:'/deyt/buy/benchmarkFreight/page', // 基准运费列表
    benchmarkSave:'/deyt/buy/benchmarkFreight/save', // 基准运费新增
    benchmarkDetail:'/deyt/buy/benchmarkFreight/detail', // 基准运费详情
    benchmarkUpdate:'/deyt/buy/benchmarkFreight/update', // 基准运费更新
    benchmarkDel:'/deyt/buy/benchmarkFreight/delete', // 基准运费删除
    buyGroupInputType:'/deyt/buy/pub/buyGroupInputType', // 装卸地数据
    buyRegionPrice:'/deyt/buy/benchmark/buyRegionPrice', // 根据区划信息获得运费
    insideListingPrice:'/deyt/buy/insideListingPrice/listPc', // 内部挂牌价信息
    freightList:'/deyt/buy/insideListingPrice/freightList', //  查看基准信息列表
    freightScreen:'/deyt/buy/insideListingPrice/freightScreen', //  查看基准信息列表
    pointForTem:'/deyt/buy/insideListingPrice/pointForTem', //  查看基准信息列表
    insideListingPriceLine:'/deyt/buy/insideListingPrice/line', //  7日折线图
    insideListingPriceLineP3:'/deyt/buy/insideListingPrice/lineP3', //  7日折线图P3
    dateAndWeek:'/deyt/buy/insideListingPrice/dateAndWeek', //  获取一周信息
    commonlyUsed:'/deyt/buy/pub/commonlyUsed', //  获取常用数据
    distributionType:'/deyt/buy/pub/distributionType', //  集团采购配送类型
    purchaseType:'/deyt/buy/pub/purchaseType', //  采购量类型
    contTransport:'/deyt/buy/pub/contTransport', //  运输票制信息
    purchaseVolume:'/deyt/buy/pub/purchaseVolume', //  根据供应商，采购主体判断采购量类型
    buyFixedCompanyType:'/deyt/buy/pub/buyFixedCompanyType', //  获取固定公司code

    adornmentMonadInsidePage:'/deyt/buy/adornmentMonadInside/page', //  内部充装生成l-cng 分页
    adornmentMonadInsideDetail:'/deyt/buy/adornmentMonadInside/detail', //  内部充装生成l-cng 详情
    adornmentMonadInsideBuyContList:'/deyt/buy/adornmentMonadInside/buyContList', //  内部充装生成l-cng 获取合同信息
    adornmentMonadInsideAdornmentGenerate:'/deyt/buy/adornmentMonadInside/adornmentGenerate', //  内部充装生成l-cng 生成
    adornmentMonadInsideInvalidGenerate:'/deyt/buy/adornmentMonadInside/invalidGenerate', //  内部充装生成l-cng 取消生成
  },
  purchase:{
    loadList:"/deyt/base/basePretend/list",//装卸地列表
    loadSave:"/deyt/base/basePretend/save",//装卸地新建保存
    loadUpdate:"/deyt/base/basePretend/update",
    loadDetail:"/deyt/base/basePretend/detail",//装卸地详情
    loadTrade:"/deyt/base/basePretend/record",//装卸地贸易公司
    loadDelete:"/deyt/base/basePretend/del",//删除装卸地
    planRemind:"/deyt/buy/plan/planRemind",//提醒
    contState:"/deyt/buy/pub/contState",//采购合同状态
    prodType:"/deyt/buy/pub/contType",//采购合同产品类型
    contList:"/deyt/buy/contract/list",//采购合同列表
    contSave:"/deyt/buy/contract/save",//采购合同新建保存
    contUpdate:"/deyt/buy/contract/update",//采购合同编辑保存
    deletcontract:"/deyt/buy/contract/del",//删除合同
    approvecont:"/deyt/buy/contract/Approve",//审批
    getDetail:"/deyt/buy/contract/Detail",//合同详情
    contStop:"/deyt/buy/contract/Termination",//终止合同
    contInvalid:"/deyt/buy/contract/Invalid",//作废合同
    sureCont:"/deyt/buy/contract/Sure",//确认执行
    supcontList:"/deyt/buy/contract/supplement",//补充合同列表
    planList:"/deyt/buy/plan/list",//总公司计划
    planSave:"/deyt/buy/plan/save",//新建计划安排保存
    planGenerateSave:"",//新建计划安排同步生成任务
    planLayoutSave:"/deyt/buy/plan/layout",//根据历史排明日计划
    planUpdate:"/deyt/buy/plan/update",//编辑某一单元格保存
    planDetail:"/deyt/buy/plan/detail",//查看某一单元格数据
    planDel:"/deyt/buy/plan/sureOrDel",//删除某一个计划安排
    planGenerate:"",//某一条数据生成任务
    planUseGasList:"/deyt/buy/planUseGas/list",//用气计划列表子公司

    planUseGasWeek:"/deyt/buy/planUseGas/week",//新建计划，一周表头
    planUseGasNewTable:"/deyt/buy/planUseGas/newTable",//新建计划，表格
    planUseGasSave:"/deyt/buy/planUseGas/save",//新建计划保存
    planUseGasDetailSave:"/deyt/buy/planUseGas/detailSave",//编辑计划保存
    planUseGasDetail:"/deyt/buy/planUseGas/detail",//查看计划
    planUseGasDel:"/deyt/buy/planUseGas/del",//删除某一个计划

    orderList:"/deyt/buy/documents/list",//采购单列表
    orderDetail:"/deyt/buy/documents/detail",//采购单详情
    buyContList:"/deyt/buy/pub/buyContList",//合同列表
    gasList:"/deyt/base/gas/gasCompanyList",//气源地选择
    contprice:"/deyt/buy/pub/buyContDetail",//获取合同产品和价格模式
    siteList:"/deyt/base/basePretend/listAll",//装卸地
    listAllByCompanyId:"/deyt/base/basePretend/listAllByCompanyId",//装卸地
    orderSave:"/deyt/buy/documents/save",//新建保存
    orderUpdate:"/deyt/buy/documents/update",//更新保存
    orderDel:"/deyt/buy/documents/invalidOrDel",//作废和删除采购单
    documentsexport:"/deyt/buy/documents/export",//导出采购单

    documentsError:"/deyt/buy/documentsError/list",//异常采购单
    sureError:"/deyt/buy/documentsError/sure",//已处理
    againError:"/deyt/buy/documentsError/again",//重新导入
    generateError:"/deyt/buy/documentsError/generate",//生成采购单

    ordersettle:"/deyt/buy/settlement/newAdd",//采购结算新建查询
    settlementList:"/deyt/buy/settlement/list",//采购结算单列表
    settleSave:"/deyt/buy/settlement/save",//新建保存
    settleDetail:"/deyt/buy/settlement/detail",//结算单详情
    settleDel:"/deyt/buy/settlement/sureOrDel",//结算单删除和作废
    settleupdate:"/deyt/buy/settlement/update",//对账完成保存
    settleExport:"/deyt/buy/settlement/export",//导出

    invoiceList:"/deyt/buy/invoice/list",//获取对账单
    invoiceConfirm:"/deyt/buy/invoice/confirm",//新建开票对账单内容
    invoiceDetail:"/deyt/buy/invoice/detail",//收票详情

    confirmsettle:"/deyt/buy/invoicing/confirm",//新建开票对账单内容
    invoicedetai:"/deyt/buy/invoicing/BuyDetail",//收票详情

    orderformList:"/deyt/buy/report/buyContList",//采购报表列表
    orderformDetail:"/deyt/buy/report/detail",//采购报表详情
    orderFormExport:"/deyt/buy/report/export",//导出报表

    supplierBugetList:"/deyt/buy/suppliers/list",//供应商预算列表
    bugetDetail:"/deyt/buy/suppliers/detail",//预算详情
    weekType:"/deyt/buy/suppliers/weekType",//周期选择列表
    saveSupplier:"/deyt/buy/suppliers/save",//保存供应商预算
    payBugetList:"/deyt/buy/paying/list",//付款单位预算
    savePay:"/deyt/buy/paying/save",//付款单位预算保存

    rebatesList:"/deyt/buy/rebates/list",//调差管理列表
    rebateSave:"/deyt/buy/rebates/save",//保存调差
    rebateDetail:"/deyt/buy/rebates/detail",//调差详情
    rebateUpdate:"/deyt/buy/rebates/update",//更新保存
    rebateDel:"/deyt/buy/rebates/del",//删除调差

    myLine:"/deyt/buy/my/line",//近7日折现
    myNum:"/deyt/buy/my/num",//数字统计
    myrecord:"/deyt/buy/my/list",//历史记录

    buyDict:'/deyt/buy/dict/', // 采购字典
    logList:"/deyt/buy/planUseGas/logList",//列表的历史记录
    gasTracking:"/deyt/buy/planUseGas/tracking",//子公司计划追踪
    flowingWater:'/deyt/buy/pub/flowingWater', // 获取未关联的流水单号
    planUseGasCom:'/deyt/buy/planUseGas/company', // 获取所属公司
    useGasPlanSave:'/deyt/buy/useGasPlan/save', // 子公司计划新增

    commonlyUsedList:'/deyt/buy/commonlyUsed/list', // 采购数据常用标识列表
    carpoolPage:'/deyt/buy/carpool/page', // 子公司计划列表
    carpoolInvalidCarpool:'/deyt/buy/carpool/invalidCarpool', // 子公司计划列表作废
    carpoolDelete:'/deyt/buy/carpool/delete', // 删除采购拼车
    carpoolSubmitCarpool:'/deyt/buy/carpool/submitCarpool', // 子公司计划列表提交
    carpoolSevendayplan:'/deyt/buy/carpool/sevendayplan', // 查看7日已提交计划
    carpoolSave:'/deyt/buy/carpool/save', // 保存采购拼车
    carpoolDetail:'/deyt/buy/carpool/detail', // 采购拼车详情
    carpoolUpdate:'/deyt/buy/carpool/update', // 采购拼车编辑
    carpoolCompanyList:'/deyt/buy/carpool/companyList', //
    carpoolGetSiteStatisticInfo:'/deyt/buy/carpool/getSiteStatisticInfo', //根据站点id获取余量

    preferentialClausePage:'/deyt/buy/preferentialClause/page', // 优惠条款列表
    preferentialClauseSave:'/deyt/buy/preferentialClause/save', // 保存优惠条款
    preferentialClauseUpdate:'/deyt/buy/preferentialClause/update', // 编辑优惠条款
    preferentialClauseDetail:'/deyt/buy/preferentialClause/detail', // 优惠条款详情
    preferentialClauseTermination:'/deyt/buy/preferentialClause/termination', // 中止优惠条款
    preferentialClauseListTakeEffect:'/deyt/buy/preferentialClause/listTakeEffect', // 查询正在生效中的数据

    priceConfirmationPage:'/deyt/buy/priceConfirmation/page', // 价格确认函表列表
    priceConfirmationSave:'/deyt/buy/priceConfirmation/save', // 价格确认函表新增
    priceConfirmationUpdate:'/deyt/buy/priceConfirmation/update', // 价格确认函表修改
    priceConfirmationDetail:'/deyt/buy/priceConfirmation/detail', // 价格确认函表详情
    priceConfrimationStop:'/deyt/buy/priceConfirmation/updateState',//价格确认函提前终止

    contractPage:'/deyt/buy/contract/page', // 采购合同分页
    contractSave:'/deyt/buy/contract/save', // 采购合同保存
    contractUpdate:'/deyt/buy/contract/update', // 采购合同保存
    contractDetail:'/deyt/buy/contract/Detail', // 采购合同详情
    contractBuyContractApprove:'/deyt/buy/contract/buyContractApprove', // 采购合同审核
    contractBuyContractDel:'/deyt/buy/contract/buyContractDel', // 采购合同删除
    contractBuyContractInvalid:'/deyt/buy/contract/buyContractInvalid', // 采购合同作废
    contractBuyContractSure:'/deyt/buy/contract/buyContractSure', // 采购合同确认执行
    contractBuyContracttermination:'/deyt/buy/contract/buyContracttermination', // 采购合同提前终止
    contractSupplement:'/deyt/buy/contract/supplement', // 补充合同列表

    planOrderCarpoolList:'/deyt/buy/planOrder/carpoolList', // 采购拼车未确认列表
    planOrderPriceDayList:'/deyt/buy/planOrder/priceDayList', // 采购合约价信息
    planOrderContractGasDayList:'/deyt/buy/planOrder/contractGasDayList', // 合同每日提气量列表
    planOrderContractSave:'/deyt/buy/planOrder/save', // 新增采购计划
    planOrderContractExistenceContract:'/deyt/buy/planOrder/existenceContract', // 获取合同id
    planOrderBackOff:'/deyt/buy/planOrder/backOff', // 退回
    planOrderPage:'/deyt/buy/planOrder/page', // 采购计划分页
    planOrderUpdateDetail:'/deyt/buy/planOrder/updateDetail', // 修改查看
    planOrderUpdate:'/deyt/buy/planOrder/update', // 修改
    planOrderDetail:'/deyt/buy/planOrder/detail', // 查看
    planOrderRevoke:'/deyt/buy/planOrder/revoke', // 撤销
    planOrderApproval:'/deyt/buy/planOrder/Approval', // 撤销
    planOrderInvalidState:'/deyt/buy/planOrder/invalidState', // 撤销

    documentsPage:'/deyt/buy/documents/page', // 采购单-列表
    documentsSave:'/deyt/buy/documents/save', // 采购单-新增
    documentsUpdate:'/deyt/buy/documents/update', // 采购单-修改
    documentsUpdatePrice:'/deyt/buy/documents/updatePrice', // 采购单-调价
    documentsCngDetail:'/deyt/buy/documents/cngDetail', // 采购单-详情
    documentsCheck:'/deyt/buy/documents/check', // 采购单-核对
    documentsLngDetail:'/deyt/buy/documents/lngDetail', // 采购单-详情
    documentsInvalid:'/deyt/buy/documents/invalid', // 采购单-作废
    documentsApprove:'/deyt/buy/documents/approve', // 采购单-审批

    settlementAmountPage:'/deyt/buy/settlementAmount/page', // 修改结算单-列表
    settlementAmountUpdate:'/deyt/buy/settlementAmount/update', // 修改结算单-修改
    settlementAmountDetail:'/deyt/buy/settlementAmount/detail', // 修改结算单-详情

    planOrderGetContractList:'/deyt/buy/planOrder/getContractList', // 获取合同id
    priceConfirmationList:'/deyt/buy/priceConfirmation/list', // 价格确认函表列表-新建cng采购单使用

    contrastAmountPage:'/deyt/buy/contrastAmount/page', // 采购对量单分页
    documentsList:'/deyt/buy/documents/list', // 采购单列表-采购对量单使用
    contrastAmountSave:'/deyt/buy/contrastAmount/save', // 新增采购对量单
    contrastAmountDetail:'/deyt/buy/contrastAmount/detail', // 新增采购对量单
    contrastAmountExport:'/deyt/buy/contrastAmount/export', //  导出采购对量单
    contrastAmountUpdate:'/deyt/buy/contrastAmount/update', // 修改采购对量单
    contrastAmountCheck:'/deyt/buy/contrastAmount/check', // 采购对量单对量
    contrastAmountInvalid:'/deyt/buy/contrastAmount/invalid', // 采购对量单作废
    contrastAmountList:'/deyt/buy/contrastAmount/list', // 采购对量单列表-采购付款项使用

    paymentPage:'/deyt/buy/payment/page', // 采购付款项分页
    paymentSave:'/deyt/buy/payment/save', // 采购付款项新增
    paymentUpdate:'/deyt/buy/payment/update', // 采购付款项修改
    paymentDetail:'/deyt/buy/payment/detail', // 采购付款项-详情
    paymentInvalid:'/deyt/buy/payment/invalid', // 采购付款项-作废
    paymentApprove:'/deyt/buy/payment/approve', // 采购付款项-审批
    paymentExport:'/deyt/buy/payment/export', // 采购付款项-导出
    paymentList:'/deyt/buy/payment/list', // 采购付款项列表---采购结算单使用
    paymentDetailByContrastAmountId:'/deyt/buy/payment/detailByContrastAmountId', // 查询采购付款项

    statementPage:'/deyt/buy/statement/page', // 采购结算单列表
    statementSave:'/deyt/buy/statement/save', // 采购结算单新增
    statementUpdate:'/deyt/buy/statement/update', // 采购结算单修改
    statementDetail:'/deyt/buy/statement/detail', // 采购结算单详情
    statementInvalid:'/deyt/buy/statement/invalid', // 采购付款项-作废
    statementPrintDetail:'/deyt/buy/statement/printDetail', // 采购付款项-打印

    statisticsAmount:'/deyt/buy/statistics/amount', //采购量汇总
    statisticsLine:'/deyt/buy/statistics/line', //LNG/CNG近7日曲线图

    buyUseGasPlanState:'/deyt/buy/pub/buyUseGasPlanState', // 子公司状态
    buyUseGasPlanDetail:'/deyt/buy/useGasPlan/detail', // 子公司状态-详情
    buyUseGasPlanUpdate:'/deyt/buy/useGasPlan/update', // 子公司状态-编辑
    buyUseGasPlanInvalid:'/deyt/buy/useGasPlan/invalid', // 子公司状态-作废
    buyUseGasPlanDel:'/deyt/buy/useGasPlan/del', // 子公司状态-删除
    buyUseGasPlanConfirm:'/deyt/buy/useGasPlan/confirm', // 子公司状态-确认
    buyUseGasPlanAgainConfirm:'/deyt/buy/useGasPlan/againConfirm', // 子公司状态-删除
    // planOrderPage:'/deyt/buy/planOrder/page', // 总公司确认采购计划-分页
    // buyPlanApprovalState:'/deyt/buy/pub/buyPlanApprovalState', // 总公司确认采购计划-审核状态
    // buyPlanOrderState:'/deyt/buy/pub/buyPlanOrderState', // 总公司确认采购计划-确认状态
    // planOrderAddList:'/deyt/buy/planOrder/addList', // 新增查询
    // planOrderBackOff:'/deyt/buy/planOrder/backOff', // 回退
    // planOrderSave:'/deyt/buy/planOrder/save', // 总公司确认采购计划-保存
    // planOrderDetail:'/deyt/buy/planOrder/detail', // 总公司确认采购计划-详情
    // planOrderRevoke:'/deyt/buy/planOrder/revoke', // 总公司确认采购计划-撤销
    // planOrderUpdate:'/deyt/buy/planOrder/update', // 总公司确认采购计划-编辑
    // planOrderBatchApproval:'/deyt/buy/planOrder/batchApproval', // 总公司确认采购计划-审批
    // planOrderApprovalWithdrawal:'/deyt/buy/planOrder/approvalWithdrawal', // 审批撤销
    documentsNewDetail:'/deyt/buy/documents/newDetail', // 采购新详情
    documentsExcelList:'/deyt/buy/documents/excelList', // 导出
    documentsExport:'/deyt/buy/documents/export', // 新导出
    //储罐存量
    lngPriceDelete:'/deyt/buy/lngPrice/delete', // 储罐存量删除
    lngPriceDetail:'/deyt/buy/lngPrice/detail', // 储罐存量详情
    lngPricePage:'/deyt/buy/lngPrice/page', // 储罐存量分页
    lngPriceAdd:'/deyt/buy/lngPrice/save', // 储罐存量新建
    lngPriceUpdate:'/deyt/buy/lngPrice/update', // 储罐存量更新
    getStock:'/deyt/buy/lngPrice/getStock', // 储罐存量更新
    /*LNG出入库管理start*/
    lngStorageList:'/deyt/buy/lngStorage/list', // LNG出入库管理-列表
    lngStorageDetail:'/deyt/buy/lngStorage/detail', // LNG出入库管理-查询实时库存量
    lngStorageUpdate:'/deyt/buy/lngStorage/update', // LNG出入库管理-更新

    lngStorageRecordPage:'/deyt/buy/lngStorageRecord/page', // LNG出入库记录-列表
    lngStorageRecordSave:'/deyt/buy/lngStorageRecord/save', // LNG出入库记录-新增
    lngStorageRecordUpdate:'/deyt/buy/lngStorageRecord/update', // LNG出入库记录-更新
    lngStorageRecordDelete:'/deyt/buy/lngStorageRecord/delete', // LNG出入库记录-删除
    lngStorageRecordApprove:'/deyt/buy/lngStorageRecord/approve', // LNG出入库记录-发起审批


    /*LNG出入库管理end*/
  },
  prod: {
    prodList: "/deyt/base/prod/prodList" //获取产品类型
  },
  file: {
    supload: "/deyt/file/supload", // 文件上传新接口校验了token
    pubUpload: "/deyt/file/pubUpload", // 文件上传
    uppload: "/deyt/file/upload", // 合同文件上传仅销售合同使用后续上传用上面接口
   // preview: "/deyt/file/preview" // 文件预览
    preview: "/deyt", // 文件预览
    previewImg: "/deyt/file/preview", // 文件预览
    uploadLogo: "/deyt/file/upload/logo",//上传logo

  },
  transportwo:{
    truckPath: "/deyt/iot/truck/path", //运输单详情 - 车辆- 轨迹
    orderSave:"/deyt/transport/order/save", //"运输单新建保存"
    cylinderComplete:"/deyt/transport/order/cylinder/complete", //"运输单装卸地钢瓶-装卸完成"
    cylinder:"/deyt/transport/app/transport/cylinder",//获取钢瓶
    tollType:"/deyt/transport/pub/toll/item/type",//通行费用类型
    tollList:"/deyt/transport/toll/item/page",//通行费列表
    tollSave:"/deyt/transport/toll/item/save",//新增通行费
    tollUpdate:"/deyt/transport/toll/item/update",//编辑通行费

    saturationList:"/deyt/transport/saturation/page",//饱和度列表
    saturationdetail:"/deyt/transport/saturation/truck",//饱和度明细
    saturationdelete:"/deyt/transport/saturation/delete",//饱和度明细删除
    saturationSave:"/deyt/transport/saturation/save",//新建饱和度明细保存

    pubtollList:"/deyt/transport/pub/toll/item/list",//通行项目列表
    routeList:"/deyt/transport/route/page",//运输线路管理
    routeSave:"/deyt/transport/route/save",//新建运输线路
    routeUpdate:"/deyt/transport/route/update",//更新运输线路
    routeDetail:"/deyt/transport/route/detail",//运输线路详情
    pathSave:"/deyt/transport/route/path-save",//路径规划保存
    getPathpoint:"/deyt/transport/route/path-point",//获取历史路径
    exportRoute:"/deyt/transport/route/export",//导出列表
    truckPoint:"/deyt/transport/route/truck-point",//车辆路径坐标

    taskList:"/deyt/transport/task/pack/page",//任务单列表transportCompanyId
    oftenlist:"/deyt/transport/pub/site/often-list",//常用站点
    tasksave:"/deyt/transport/task/pack/save",//新建任务单
    taskdetail:"/deyt/transport/task/pack/detail",//任务单详情
    taskupdate:"/deyt/transport/task/pack/update",//更新任务单
    taskdispatch:"/deyt/transport/task/pack/view",//调度单详情
    oftenTruck:"/deyt/transport/pub/vehicle/truck/often-list",//调度里面调车辆信息
    getPrice:"/deyt/transport/task/pack/check-price",//检验气量结算是否存在价格
    dispatchsave:"/deyt/transport/task/pack/save-dispatch",//调度单保存
    dispatchsaturation:"/deyt/transport/pub/company/saturation",//调度单饱和度
    taskInvalid:"/deyt/transport/task/pack/invalid",//作废
    taskDelete:"/deyt/transport/task/pack/delete",//删除
    taskLink:"/deyt/transport/task/pack/link-order",//任务单关联单号
    dispatchSettle:'/deyt/transport/pub/company/settle-mode',//调度选择承运公司获取结算方式

    tranceportCheck:"/deyt/transport/order/check-state",//运输单核对
    tranceportList:"/deyt/transport/order/check-page",//运输单列表
    generatePay:"/deyt/transport/check/generate/pay",//对量单生成付款项
    checkAdjust:"/deyt/transport/check/transport/adjust",//对量单调差
    pubUnload:"/deyt/transport/pub/ts-order/unload",//运输单新增卸车点时计算
    orderLink:"/deyt/transport/order/link-order",//运输单关联单号

    payType:"/deyt/transport/pub/payment/type",//付款项类型
    transportPay:"/deyt/transport/payment/page",//付款项列表
    trunkFee:"/deyt/transport/payment/truck/fee",//车辆费用搜索列表
    paySave:"/deyt/transport/payment/save",//运输付款项新建保存
    payDetail:"/deyt/transport/payment/detail",//付款项编辑详情
    payUpdate:"/deyt/transport/payment/update",//更新付款项
    payInvalid:"/deyt/transport/payment/invalid",//作废
    payDelet:"/deyt/transport/payment/delete",//删除
    payView:"/deyt/transport/payment/view",//查看详情

    billDetail:"/deyt/transport/bill/detail",//结算单编辑详情
    billUpdate:"/deyt/transport/bill/update",//结算单编辑保存
    /**/
    taskDispatchInfo:"/deyt/transport/task/pack/dispatchInfo",//任务单调度详情 - 截图
  },
  transport: {
    reflushprice:"/deyt/transport/payment/replenish/price",//运输付款项详情刷新
    bindInfo:"/deyt/transport/staff/bind/info",//司机绑定押运员和车牌号
    transportDate:"/deyt/transport/pub/company/settle-date",//新建运输对量单获取时间
    transportCheck:"/deyt/transport/check/transport/list",//新建对量单运输单查询列表
    staffOccupation:'/deyt/transport/pub/staff/Occupation', // 职位
    vehicleCategory:'/deyt/transport/pub/vehicle/category', // 车辆类别
    truckType:'/deyt/transport/pub/truck/type', // 车头类型
    vehicleModel:'/deyt/transport/pub/vehicle/model', // 车型
    trailerType:'/deyt/transport/pub/trailer/type', // 挂车类型
    trailers:'/deyt/transport/pub/trailer/list', // 挂车
    trucks:'/deyt/transport/pub/truck/list', // 车头
    truckSmission:'/deyt/transport/pub/truck/emission', // 车头排放标准
    etcTradeType:'/deyt/transport/pub/etc/trade-type', // etc交易类型
    oilCardType:'/deyt/transport/pub/oil/card-type', // 油卡类型
    oilTradeType:'/deyt/transport/pub/oil/trade-type', // 油卡交易类型
    feeType:'/deyt/transport/pub/truck/other-fee-type', // 油卡交易类型
    priceType:'/deyt/transport/pub/oil/price-type', // 油价类型
    tsPriceApproveState:'/deyt/transport/pub/ts-price/approve-state', // 运输单价审批状态
    tsPriceState:'/deyt/transport/pub/ts-price/state', // 运输单价状态
    tsPriceType:'/deyt/transport/pub/ts-price/type', // 运输单价类型
    tsProductType:'/deyt/transport/pub/product-type', // 单据产品类型
    site:'/deyt/transport/pub/site/list', // 站点
    contractApproveState:'/deyt/transport/pub/contract/approve-state', // 合同审批状态
    contractSettlementMode:'/deyt/transport/pub/contract/settlement-mode', // 合同结算方式
    contractState:'/deyt/transport/pub/contract/state', // 合同状态
    etc:'/deyt/transport/pub/etc/list', // etc
    taskState:'/deyt/transport/pub/task/state', // 任务单状态
    orderState:'/deyt/transport/pub/order/state', // 运输单状态
    orderCheckState:'/deyt/transport/pub/order/check-state', // 运输单核对状态
    emptyFull:'/deyt/transport/pub/empty-full', // 空满
    loadUnload:'/deyt/transport/pub/load-unload', // 装卸
    siteList:'/deyt/transport/pub/site/list', // 站点
    deviceSpec:'/deyt/transport/pub/device-spec', // 规格
    supercargo:'/deyt/transport/pub/staff/supercargo', // 押运员
    driver:'/deyt/transport/pub/staff/driver', // 驾驶员
    truck:'/deyt/transport/pub/vehicle/truck', // 车辆车头列表
    trailer:'/deyt/transport/pub/trailer/list', // 驾驶员
    settlementMode:'/deyt/transport/pub/settlement-mode', // 运输结算方式
    getPrice:'/deyt/transport/pub/ts-order/price', // 单据获取运输价格
    rule:'/deyt/transport/pub/ts-price/rule', // 运输规则
    amountCheckState:'/deyt/transport/pub/check/state', // 运输对量单状态
    billState:'/deyt/transport/pub/bill/state', // 运输结算单状态
    /**---------------------------------------业务---------------------------------------------------*/
    staffList:'/deyt/transport/staff/list', // 驾押人员列表
    staffSave:'/deyt/transport/staff/save', // 新增驾押人员
    staffUpdate:'/deyt/transport/staff/update', // 编辑驾押人员
    staffChangeState:'/deyt/transport/staff/changeState', // 停启用驾押员
    modelList:'/deyt/transport/model/list', // 车型列表
    modelSave:'/deyt/transport/model/save', // 新建车型
    modelUpdate:'/deyt/transport/model/update', // 编辑车型
    modelChangeState:'/deyt/transport/model/changeState', // 停启用车型
    modelDelete:'/deyt/transport/model/delete', // 停启用驾押员
    truckTrailerList:'/deyt/transport/truckTrailer/list', // 车头/挂车列表
    truckTrailerSave:'/deyt/transport/truckTrailer/save', // 新增车头/挂车
    truckTrailerDetail:'/deyt/transport/truckTrailer/detail', // 详情-车头/挂车
    truckTrailerUpdate:'/deyt/transport/truckTrailer/update', // 编辑车头/挂车
    truckTrailerChangeState:'/deyt/transport/truckTrailer/changeState', // 停启用车头/挂车
    truckTrailerDelete:'/deyt/transport/truckTrailer/delete', // 删除车头/挂车
    vehicleList:'/deyt/transport/vehicle/list', // 车辆列表
    vehicleSave:'/deyt/transport/vehicle/save', // 新建车辆
    vehicleDetail:'/deyt/transport/vehicle/detail', // 车辆详情
    vehicleUpdate:'/deyt/transport/vehicle/update', // 编辑车辆
    vehicleDelete:'/deyt/transport/vehicle/delete', // 删除车辆
    vehicleChangeState:'/deyt/transport/vehicle/changeState', // 停启用车辆
    etcList:'/deyt/transport/etc/list', // ETC列表
    etcSave:'/deyt/transport/etc/save', // 新建ETC
    etcDetail:'/deyt/transport/etc/detail', // ETC详情
    etcUpdate:'/deyt/transport/etc/update', // 编辑ETC
    etcChangeState:'/deyt/transport/etc/changeState', // 停启用ETC
    etcDelete:'/deyt/transport/etc/delete', // 删除ETC
    etcTradeList:'/deyt/transport/etc-trade/list', // ETC交易列表
    etcTradeDetail:'/deyt/transport/etc-trade/detail', // ETC详情
    etcTradeSave:'/deyt/transport/etc-trade/save', // 新建ETC交易
    etcTradeUpdate:'/deyt/transport/etc-trade/update', // 编辑ETC交易
    etcTradeDelete:'/deyt/transport/etc-trade/delete', // 删除ETC交易
    oilCardList:'/deyt/transport/oil-card/list', // 油卡列表
    oilCardSave:'/deyt/transport/oil-card/save', // 新建油卡
    oilCardDetail:'/deyt/transport/oil-card/detail', // 油卡详情
    oilCardUpdate:'/deyt/transport/oil-card/update', // 编辑油卡
    oilCardChangeState:'/deyt/transport/oil-card/changeState', // 停启用油卡
    oilCardDelete:'/deyt/transport/oil-card/delete', // 删除油卡
    oilCardTradeList:'/deyt/transport/oil-card-trade/list', // 油卡交易列表
    oilCardTradeSave:'/deyt/transport/oil-card-trade/save', // 新建油卡交易
    oilCardTradeDetail:'/deyt/transport/oil-card-trade/detail', // 油卡交易详情
    oilCardTradeUpdate:'/deyt/transport/oil-card-trade/update', // 编辑油卡交易
    oilCardTradeDelete:'/deyt/transport/oil-card-trade/delete', // 删除油卡交易
    otherFeesList:'/deyt/transport/truck-other-fee/list', // 其他费用列表
    otherFeesSave:'/deyt/transport/truck-other-fee/save', // 新建其他费用
    otherFeesDetail:'/deyt/transport/truck-other-fee/detail', // 其他费用详情
    otherFeesUpdate:'/deyt/transport/truck-other-fee/update', // 编辑其他费用
    otherFeesDelete:'/deyt/transport/truck-other-fee/delete', // 删除其他费用
    gasPriceList:'/deyt/transport/ts-price/list', // 气量运输单价列表
    gasPriceSave:'/deyt/transport/ts-price/save', // 新建气量运输单价
    gasPriceDetail:'/deyt/transport/ts-price/detail', // 气量运输单价调价
    gasPriceView:'/deyt/transport/ts-price/view', // 气量运输单价详情
    gasPriceApprove:'/deyt/transport/ts-price/approve', // 审批
    gasPriceAdjust:'/deyt/transport/ts-price/adjust', // 调整气量运输单价
    gasPriceDelete:'/deyt/transport/ts-price/delete', // 删除气量运输单价
    oilPriceList:'/deyt/transport/oil-price/list', // 运输油价列表
    oilPriceSave:'/deyt/transport/oil-price/save', // 新建运输油价
    oilPriceUpdate:'/deyt/transport/oil-price/update', // 编辑运输油价
    oilPriceDelete:'/deyt/transport/oil-price/delete', // 删除运输油价
    contractList:'/deyt/transport/contract/list', // 运输合同列表
    contractSave:'/deyt/transport/contract/save', // 新建运输合同
    contractDetail:'/deyt/transport/contract/detail', // 运输合同详情
    contractView:'/deyt/transport/contract/view', // 运输合同详情
    contractUpdate:'/deyt/transport/contract/update', // 编辑运输合同
    contractDelete:'/deyt/transport/contract/delete', // 删除运输合同
    contractInvalid:'/deyt/transport/contract/invalid', // 作废运输合同
    contractTerminate:'/deyt/transport/contract/terminate', // 终止运输合同
    contractApprove:'/deyt/transport/contract/approve', // 审批
    contractLinkCar:'/deyt/transport/contract/link-truck', // 关联车辆
    taskList:'/deyt/transport/task/list', // 任务单列表
    taskSave:'/deyt/transport/task/save', // 新建任务单
    taskDetail:'/deyt/transport/task/detail', // 任务单详情
    taskUpdate:'/deyt/transport/task/update', // 编辑任务单
    taskDelete:'/deyt/transport/task/delete', // 删除任务单
    taskInvalid:'/deyt/transport/task/invalid', // 作废任务单
    taskCheckPrice:'/deyt/transport/task/check-price', // 校验气量结算是否存在价格
    taskGenerateOrder:'/deyt/transport/task/generate-order', // 运输获取任务信息
    orderList:'/deyt/transport/order/page', // 运输单列表
    orderSave:'/deyt/transport/order/save', // 新建运输单
    orderDetail:'/deyt/transport/order/detail', // 运输单详情
    orderUpdate:'/deyt/transport/order/update', // 编辑运输单
    orderDelete:'/deyt/transport/order/delete', // 删除运输单
    orderInvalid:'/deyt/transport/order/invalid', // 作废运输单
    orderCheck:'/deyt/transport/order/check-state', // 核对运输单
    orderExport:'/deyt/transport/order/export', // 导出运输单
    checkList:'/deyt/transport/check/page', // 运输对量单列表
    checkSave:'/deyt/transport/check/save', // 新建运输对量单
    checkView:'/deyt/transport/check/view', // 查看运输对量单
    // checkUpdate:'/deyt/transport/check/update', // 刷新
    checkDelete:'/deyt/transport/check/delete', // 删除运输对量单
    checkInvalid:'/deyt/transport/check/invalid', // 作废运输对量单
    checkCorrect:'/deyt/transport/check/correct', // 核对正确
    checkExport:'/deyt/transport/check/export', // 导出
    checkCompanyList:'/deyt/transport/check/company/list', // 运输对量单运输公司
    billList:'/deyt/transport/bill/page', // 运输结算单列表
    billSave:'/deyt/transport/bill/save', // 新建运输结算单
    billView:'/deyt/transport/bill/view', // 查看运输结算单
    billDelete:'/deyt/transport/bill/delete', // 删除运输结算单
    billInvalid:'/deyt/transport/bill/invalid', // 作废运输结算单
    billUpdate:'/deyt/transport/bill/update', // 刷新
    billSaveFee:'/deyt/transport/bill/save-fee', // 保存其他费用项
    billComplete:'/deyt/transport/bill/complete', // 对账完成
    billExport:'/deyt/transport/bill/export', // 导出
    billCheckList:'/deyt/transport/bill/payment/list', // 选择对账单列表
    billTransportList:'/deyt/transport/bill/transport/list', // 选择对账单列表
    billTransportSaveMode:'/deyt/transport/bill/transport/save-mode', // 保存
    billVehicleFee:'/deyt/transport/bill/vehicle/fee', // 运输费用明细
    billVehicleOilFee:'/deyt/transport/bill/vehicle/oil-fee', // 查看车辆油费明细
    billVehicleOtherFee:'/deyt/transport/bill/vehicle/other-fee', // 查看车辆其他费用明细
    billVehicleTollFee:'/deyt/transport/bill/vehicle/toll-fee', // 查看车辆过路费明细
    billPrint:'/deyt/transport/bill/print', // 運輸打印
    loadUnloadList:'/deyt/transport/load-unload/list', // 运输装卸单列表
    loadUnloadSave:'/deyt/transport/load-unload/save', // 运输装卸单保存
    loadUnloadUpdate:'/deyt/transport/load-unload/update', // 运输装卸单编辑
    loadUnloadDetail:'/deyt/transport/load-unload/detail', // 运输装卸单详情
    loadUnloadDelete:'/deyt/transport/load-unload/delete', // 运输装卸单删除
    pubLoadStation:'/deyt/transport/pub/load-station', // 装车地
    truckFeeList:'/deyt/transport/truck-fee/list', // 运输家次费列表
    truckFeeSave:'/deyt/transport/truck-fee/save', // 运输家次费保存
    truckFeeUpdate:'/deyt/transport/truck-fee/update', // 运输家次费更新
    truckFeeDelete:'/deyt/transport/truck-fee/delete', // 运输家次费删除
    truckFeeDetail:'/deyt/transport/truck-fee/detail', // 运输家次费详情
    truckFeeTruckList:'/deyt/transport/truck-fee/truck-list', // 运输车辆家次
    transportList:'/deyt/transport/ts-price/transport-list', //  价格计算器-运输列表
    myTruck:'/deyt/transport/my/truck', //  我的运输单-车辆排行榜
    myOrder:'/deyt/transport/my/order', //  我的运输单-业务单据统计
    myProduct:'/deyt/transport/my/product', //  我的运输单-7日产品运输量统计
    reportTruck:'/deyt/transport/report/truck', //  报表1-车辆运输统计
    reportTsCheck:'/deyt/transport/report/ts-check', //  运输报表3-运输单核查
    reportTwoTicket:'/deyt/transport/report/two-ticket', //  报表2-两票制运输单据查询
    errorList:'/deyt/transport/error/list', //  异常运输单列表
    errorReimport:'/deyt/transport/error/reimport', //  异常运输单重新导入
    exportBill:'/deyt/transport/bill/export-bill', //  导出对账单Excel
    distanceList:"/deyt/transport/distance/list",//距离管理列表
    distancedetail:"/deyt/transport/distance/detail",//距离详情
    savedistance:"/deyt/transport/distance/save",//新增距离保存
    updatedistance:"/deyt/transport/distance/update",//编辑距离保存
    deletedistance:"/deyt/transport/distance/delete",//删除距离

  },

  /*贸易 start*/
  trade:{
    /*字典*/
    tradeDict:'/deyt/trade/dict/', // 贸易字典
    riskDict:'/deyt/risk/dict/', // 风控字典
    /*贸易规则*/
    tradeRulePage:'/deyt/risk/tradeRule/page', // 贸易规则 - 分页
    tradeRuleSave:'/deyt/risk/tradeRule/save', // 贸易规则 - 新增
    tradeRuleUpdate:'/deyt/risk/tradeRule/update', // 贸易规则 - 编辑
    tradeRuleDetail:'/deyt/risk/tradeRule/detail', // 贸易规则 - 详情
    tradeRuleDelete:'/deyt/risk/tradeRule/delete', // 贸易规则 - 详情
    /*贸易客户*/
    tradeCustomerList:'/deyt/trade/customer/list', // 贸易规则 - 列表
    tradeCustomerPage:'/deyt/trade/customer/page', // 贸易规则 - 分页
    tradeCustomerSave:'/deyt/trade/customer/save', // 贸易规则 - 新增
    tradeCustomerUpdate:'/deyt/trade/customer/update', // 贸易规则 - 编辑
    tradeCustomerDelete:'/deyt/trade/customer/delete', // 贸易规则 - 删除
    tradeCustomerDetail:'/deyt/trade/customer/detail', // 贸易规则 - 详情
    tradeCustomerEnable:'/deyt/trade/customer/enable', // 贸易规则 - 启用禁用
    tradeCustomerRiskInfo:'/deyt/trade/customer/riskInfo', // 贸易客户 - 风控信息
    /*价格确认函*/
    priceConfirmList:'/deyt/trade/priceConfirmation/list', // 价格确认函 - 列表
    priceConfirmPage:'/deyt/trade/price/confirmation/page', // 价格确认函 - 分页
    priceConfirmSave:'/deyt/trade/price/confirmation/save', // 价格确认函 - 新增
    priceConfirmUpdate:'/deyt/trade/price/confirmation/update', // 价格确认函 - 编辑
    priceConfirmInvalid:"/deyt/trade/price/confirmation/invalid",// 价格确认函 - 作废
    priceConfirmDelete:'/deyt/trade/priceConfirmation/delete', // 价格确认函 - 删除
    priceConfirmDetail:'/deyt/trade/price/confirmation/detail', // 价格确认函 - 详情
    priceConfirmPrint:'/deyt/trade/price/confirmation/print',//价格确认函-打印
    companycontract:'/deyt/trade/pub/company/contract',//新建时根据公司获取联系人信息
    priceConfirmApprove:'/deyt/trade/price/confirmation/approve',//审批
    /*贸易需求单*/
    approveDemand:'/deyt/trade/demand/unloadInfo', // 提交审批
    priceDemandList:'/deyt/trade/requireOrder/list', // 贸易需求单 - 列表
    priceDemandPage:'/deyt/trade/requireOrder/page', // 贸易需求单 - 分页
    priceDemandSave:'/deyt/trade/requireOrder/save', // 贸易需求单 - 新增
    priceDemandUpdate:'/deyt/trade/requireOrder/update', // 贸易需求单 - 编辑
    priceDemandDelete:'/deyt/trade/requireOrder/delete', // 贸易需求单 - 删除
    priceDemandDetail:'/deyt/trade/requireOrder/detail', // 贸易需求单 - 详情
    priceDemandCancel:'/deyt/trade/requireOrder/cancel', // 贸易需求单 - 详情
    priceDemandCheck:'/deyt/trade/requireOrder/check', // 贸易需求单 - 尝试风控
    unloadInfo:'/deyt/trade/requireOrderDetail/list', // 获取卸车信息
    priceDemandConfirm:'/deyt/trade/requireOrder/confirm', // 确认需求单
    findListWithoutCompany:'/deyt/base/basePretend/findListWithoutCompany', // 确认需求单

    /*气源地*/
    gasList:"/deyt/buy/pub/gasCompanyList",//气源地选择
    /*贸易销售单*/
    tradeSaleList:'/deyt/trade/saleOrder/list', // 贸易销售单 - 列表
    tradeSalePage:'/deyt/trade/saleOrder/page', // 贸易销售单 - 分页
    tradeSaleCheck:'/deyt/trade/saleOrder/check', // 贸易销售单 -核对
    tradeSaleDelete:'/deyt/trade/saleOrder/delete', // 贸易销售单 - 删除
    tradeSaleDetail:'/deyt/trade/saleOrder/detail', // 贸易销售单 - 详情
    tradeSaleImage:'/deyt/trade/saleOrder/notice',//贸易销售单 - 生成图片信息
    tradeSaleDelivery:'/deyt/trade/saleOrder/change/delivery',//贸易销售单-修改运输方式
    tradeSaleExport:"/deyt/trade/saleOrder/export",//贸易销售单导出
    tradeSaleChange:'/deyt/trade/saleOrder/change/price-quantity', // 贸易销售单 - 改价改量
     /*贸易对量单*/
     tradeCheckList:'/deyt/trade/check/order/page',//贸易对量列表
     tradeCheckDetail:"/deyt/trade/check/order/detail",//详情
     tradeCheckSave:"/deyt/trade/check/order/save",//新建保存
     tradeCheckUpdate:"/deyt/trade/check/order/update",//编辑保存
     tradeCheckSale:'/deyt/trade/check/order/sale',//新建是的查询
     tradeCheckReceipt:'/deyt/trade/check/order/receipt',//生成收款项
     tradeCheckDelete:'/deyt/trade/check/order/delete',//删除
     tradeCheckInvalid:'/deyt/trade/check/order/invalid',//作废
     tradeExport:'/deyt/trade/check/order/export',//导出
     tradeCheckComplete:'/deyt/trade/check/order/complete',//对量完成
    /* 贸易收款项 */
    tradeReceipt:'/deyt/trade/receipt/page',//收款项列表
    tradeMoneyConfig:'/deyt/trade/receipt/getItemDict',//新建时项目名称
    getTradeCont:'/deyt/trade/receipt/getConId',//获取合同id
    tradeReceiptDetail:'/deyt/trade/receipt/detail',//收款项详情
    tradeReceiptSave:'/deyt/trade/receipt/save',//新建保存
    tradeReceiptUpdate:'/deyt/trade/receipt/update',//编辑保存
    tradeReceiptInvalid:'/deyt/trade/receipt/invalid',//作废
    tradeReceiptDelet:'/deyt/trade/receipt/delete',//删除
    tradeReceiptApprove:'/deyt/trade/receipt/approve',//审批
    tradeReceiptConfirm:'/deyt/trade/receipt/confirm',//确认

    tradeReceiptPriceChangeDetail:'/deyt/trade/receipt/priceChangeDetail',//改价查询
    tradeReceiptPriceChange:'/deyt/trade/receipt/priceChange',//改价
    /*贸易结算单*/
    tradeSettleList:'/deyt/trade/receipt/list', // 贸易结算单 - 新建查询按钮
    tradeSettlePage:'/deyt/trade/tradeStatementOrder/extPage', // 贸易结算单 - 分页
    tradeSettleSave:'/deyt/trade/tradeStatementOrder/save', // 贸易结算单 - 新增
    tradeSettleUpdate:'/deyt/trade/tradeStatementOrder/update', // 贸易结算单 - 编辑
    // tradeSettleCheck:'/deyt/trade/statementOrder/check', // 贸易结算单 -核对
    tradeSettleInvalid:'/deyt/trade/tradeStatementOrder/invalid',//贸易结算单- 作废
    tradeSettleDelete:'/deyt/trade/tradeStatementOrder/delete', // 贸易结算单 - 删除
    tradeSettleVeiw:'/deyt/trade/tradeStatementOrder/view', // 贸易结算单 - 详情d
    tradeSettleDetail:'/deyt/trade/tradeStatementOrder/detail',//贸易结算单-编辑详情
    tradeSettlePrint:'/deyt/trade/tradeStatementOrder/print',//贸易结算单-打印详情
    tradeSettleComplete:'/deyt/trade/tradeStatementOrder/complete',//贸易结算单-结算完成d
    selectByCompId:'/deyt/base/companyAddInfo/selectByCompId', // 贸易结算单 - 获取公司信息
    customcompany:'/deyt/trade/tradeStatementOrder/findByCompany',//贸易结算单客户接口


  },
  /*贸易 end*/
  /*绩效管理 开始*/
  kpi:{
    deductRuleSave:'/deyt/kpi/deduct/rule/save', // 新增扣分规则
    deductRuleEdit:'/deyt/kpi/deduct/rule/update', // 编辑扣分规则
    deductRuleDetail:'/deyt/kpi/deduct/rule/detail', // 扣分规则详情
    deductRuleDelet:'/deyt/kpi/deduct/rule/delete', // 删除扣分规则
    deductRuledisable:'/deyt/kpi/deduct/rule/disable', // 启用停用扣分规则
    deductRuleList:'/deyt/kpi/deduct/rule/page', // 扣分规则列表
    itemPage:'/deyt/kpi/assess/item/page', // 考核项列表
    itemSave:'/deyt/kpi/assess/item/save', // 新建考核项
    itemUpdate:'/deyt/kpi/assess/item/update', // 更新考核项
    itemDetail:'/deyt/kpi/assess/item/detail', // 考核项详情
    itemDelete:'/deyt/kpi/assess/item/delete', // 删除考核项
    assessStaffDetail:'/deyt/kpi/assess/item/staff', // 获取配置人员
    saveStaff:'/deyt/kpi/assess/item/save-staff', // 保存配置人员
    changeRule:'/deyt/kpi/assess/item/save-rule', // 更改考核规则
    itemDisable:'/deyt/kpi/assess/item/disable', // 考核项启用停用
    ruleExplain:'/deyt/kpi/pub/assess/rule-explain', // 考核规则说明
    statisPage:'/deyt/kpi/staff/statis/page', // 个人绩效列表
    staffLevel:'/deyt/kpi/staff/level', // 绩效排名
    staffCurrent:'/deyt/kpi/staff/current', // 个人当前绩效
    ruleListInit:'/deyt/kpi/pub/assess/rule/list', // 考核规则字典表
    menuListInit:'/deyt/kpi/pub/menu', // 单据字典表
    moduleListInit:'/deyt/kpi/pub/module', // 模块字典表
    resListInit:'/deyt/kpi/pub/res', // 操作字典表

    kpirole:"/deyt/kpi/pub/opt/role",//获取操作角色
    kpitype:"/deyt/kpi/pub/opt/type",//获取操作类型考核类型
    targettype:"/deyt/kpi/pub/assess/target",//获取指标项名称
    targetlist:"/deyt/kpi/assess/target/page",//指标列表
    targetdetail:"/deyt/kpi/assess/target/detail",//指标详情
    targetsave:"/deyt/kpi/assess/target/save",//保存指标
    targeupdate:"/deyt/kpi/assess/target/update",//更新指标
    targetdelet:"/deyt/kpi/assess/target/delete",//删除指标

    ruledatetype:"/deyt/kpi/pub/assess/rule/date-type",//规则日期类型
    rulecompare:"/deyt/kpi/pub/assess/rule/date-compare",//规则日期比较词
    ruleList:"/deyt/kpi/assess/rule/page",//考核规则列表
    ruledetail:"/deyt/kpi/assess/rule/detail",//考核规则详情
    rulesave:"/deyt/kpi/assess/rule/save",//保存考核规则
    ruleupdate:"/deyt/kpi/assess/rule/update",//更新考核规则
    ruledelet:"/deyt/kpi/assess/rule/delete",//删除考核规则
    ruleenable:"/deyt/kpi/assess/rule/disable",//启用禁用考核规则
    ruleKpi:"/deyt/kpi/assess/rule/explain/list",//考核规则说明

    workdict:"/deyt/base/work/order/work-type",//工单类型
    workList:"/deyt/base/work/order/page",//工单列表
    worksave:"/deyt/base/work/order/save",//新建工单
    workupdate:"/deyt/base/work/order/update",//编辑工单
    workdetail:"/deyt/base/work/order/detail",//工单详情
    workdelet:"/deyt/base/work/order/delete",//删除工单
    workdeal:"/deyt/base/work/order/deal",//处理工单
    workapprove:"/deyt/base/work/order/approve",//审批工单


    siteVisitPage:"/deyt/base/staffIotVisit/page",//审批工单
  },
  /*绩效管理 结束*/
  /*资金管理 开始*/
  fund:{
    businessDictSave:'/deyt/base/businessDict/save',
    listBusinessCode:'/deyt/base/businessDict/listBusinessCode',
    listByCode:'/deyt/base/businessDict/listByCode',
    transferAccountSave:'/deyt/base/transferAccount/save',
    transferAccountUpdate:'/deyt/base/transferAccount/update',
    transferAccountPage:'/deyt/base/transferAccount/page',
    transferAccountDisable:'/deyt/base/transferAccount/disable',
    transferAccountById:'/deyt/base/transferAccount/list',//根据公司id查已有往来账户列表
    transferAccountDetail:'/deyt/base/transferAccount/detail',
    transferInitAccounts:'/deyt/fund/transferAccount/initAccounts',//账户列表
    acctSubjectVersionDisable:'/deyt/fund/acctSubjectVersion/disable',//版本启用、停用
    lastNodeList:'/deyt/fund/acctSubject/lastNodeList',//会计科目末级科目列表
    subjectAdd:'/deyt/fund/acctSubject/save',
    subjectList:'/deyt/fund/acctSubject/page',
    subjectTypes:'/deyt/fund/acctSubject/list',
    acctSubjectVersionSave:'/deyt/fund/acctSubjectVersion/save',//新建版本
    acctSubjectVersionList:'/deyt/fund/acctSubjectVersion/list',//版本列表
    ticketApplySave:'/deyt/finance/ticketApply/save',
    ticketApplyPage:'/deyt/finance/ticketApply/page',
    ticketApplyUpdate:'/deyt/finance/ticketApply/update',
    ticketApplyDetail:'/deyt/finance/ticketApply/detail',
    ticketExport:'/deyt/finance/ticket/export',
    ticketPage:'/deyt/finance/ticket/page',
    ticketUpdate:'/deyt/finance/ticket/update',
    ticketSave:'/deyt/finance/ticket/save',
    ticketList:'/deyt/finance/ticket/list',
    invioceDisabled:'/deyt/finance/ticket/invalid',//发票作废
    ticketDetail:'/deyt/finance/ticket/detail',//发票详情
    companyByTag:'/deyt/base/company/groupCompanyByTag',//根据标签查公司
    acceptanceDraftSave:'/deyt/fund/acceptanceDraft/save',
    acceptanceDraftUpdate:'/deyt/fund/acceptanceDraft/update',
    acceptanceDraftPage:'/deyt/fund/acceptanceDraft/page',
    acceptanceDraftDetail:'/deyt/fund/acceptanceDraft/detail',
    acceptanceDraftCancel:'/deyt/fund/acceptanceDraft/payRevoke',
    acceptanceDraftCollectApprove:'/deyt/fund/accpdColletion/collectApprove',
    acceptanceDraftCollectCompelet:'/deyt/fund/accpdColletion/collectComplete',
    acceptanceDraftCollectList:'/deyt/fund/accpdColletion/page',
    acceptanceDraftListByCondition:'/deyt/fund/acceptanceDraft/list',
    acceptanceDraftListDelete:'/deyt/fund/acceptanceDraft/delete',
    acceptanceDraftListExport:'/deyt/fund/acceptanceDraft/export',
    transferOrderSave:'/deyt/fund/transferOrder/save',
    transferOrderUpdate:'/deyt/fund/transferOrder/update',
    transferOrderDetail:'/deyt/fund/transferOrder/detail',
    transferOrderCheck:'/deyt/fund/transferOrder/check',
    transferOrderPage:'/deyt/fund/transferOrder/page',
    transferOrderDelete:'/deyt/fund/transferOrder/delete',
    transferOrderExport:'/deyt/fund/transferOrder/export',
    transferOrderPayPage:'/deyt/fund/transferOrder/payPage',
    transferOrderPayPageExport:'/deyt/fund/transferOrder/payPageExport',
    transferOrderReceivePage:'/deyt/fund/transferOrder/receivePage',
    transferOrderReceivePageExport:'/deyt/fund/transferOrder/receivePageExport',
    transferOrderList:'/deyt/fund/transferOrder/list',
    payOrderSave:'/deyt/fund/payApplyOrder/save',
    payOrderUpdate:'/deyt/fund/payApplyOrder/update',
    payOrderDetail:'/deyt/fund/payApplyOrder/detail',
    paymentSave:'/deyt/fund/payApplyOrder/payment',
    draftEnable:'/deyt/fund/draftEnable',
    paymentPage:'/deyt/fund/payApplyOrder/page',
    paymentCancel:'/deyt/fund/payApplyOrder/invalid',
    accountBalance:'/deyt/fund/accountMonthStatistic/accountRemindAmountList',
    accountBalanceMonth:'/deyt/fund/accountMonthStatistic/page',
    accountBalanceMonthDetail:'/deyt/fund/accountMonthStatistic/detail',
    accountBalanceMonthAdd:'/deyt/fund/accountMonthStatistic/save',
    accountBalanceMonthUpdate:'/deyt/fund/accountMonthStatistic/update',
    accountBalanceMonthExport:'/deyt/fund/accountMonthStatistic/export',
    payApplyOrderApprove:'/deyt/fund/payApplyOrder/approve',
    payApplyOrderDelet:'/deyt/fund/payApplyOrder/delete',
    payApplyOrderExport:'/deyt/fund/payApplyOrder/export',
    approveStateDict:'/deyt/base/pub/approveStateDict',
    lastListGroupByContNo:'/deyt/fund/payApplyOrder/lastListGroupByContNo',
    transferMerchantDelet:'/deyt/base/transferMerchant/delete',
    transferMerchantDetail:'/deyt/base/transferMerchant/detail',
    transferMerchantGetOne:'/deyt/base/transferMerchant/getOne',
    transferMerchantList:'/deyt/base/transferMerchant/list',
    transferMerchantOption:'/deyt/base/transferMerchant/option',
    transferMerchantPage:'/deyt/base/transferMerchant/page',
    transferMerchantSave:'/deyt/base/transferMerchant/save',
    transferMerchantUpdate:'/deyt/base/transferMerchant/update',
    staffListByPermission:'/deyt/base/staff/listByPermission',
    sendFin:'/deyt/fund/payApplyOrder/send-fin',
    accountExport:'/deyt/fund/accountMonthStatistic/accountExport',
    draftRemark:'/deyt/fund/acceptanceDraft/remark',
    accpdCollectionApplyPage:'/deyt/fund/accpdCollectionApply/page',
    accpdCollectionApplySave:'/deyt/fund/accpdCollectionApply/save',
    accpdCollectionApplyUpdate:'/deyt/fund/accpdCollectionApply/update',
    collectGetApplyById:'/deyt/fund/accpdCollectionApply/getApplyById',
    detailExport:'/deyt/fund/accpdCollectionApply/detailExport',
    collectDelete:'/deyt/fund/accpdCollectionApply/delete',
    applyCollect:'/deyt/fund/accpdCollectionApply/collect',
    collectionApprove:'/deyt/fund/accpdCollectionApply/approve',
    discountPage:'/deyt/fund/accpdDiscountApply/page',
    discountDelete:'/deyt/fund/accpdDiscountApply/delete',
    discountApprove:'/deyt/fund/accpdDiscountApply/approve',
    discountDetailExport:'/deyt/fund/accpdDiscountApply/detailExport',
    discountGetApplyById:'/deyt/fund/accpdDiscountApply/getApplyById',
    discountSave:'/deyt/fund/accpdDiscountApply/save',
    discountUpdate:'/deyt/fund/accpdDiscountApply/update',
    applyDiscount:'/deyt/fund/accpdDiscountApply/discount',
    collectionPush:'/deyt/fund/accpdCollectionApply/push',
    discountPush:'/deyt/fund/accpdDiscountApply/push',
    virtualAccountPage:'/deyt/fund/virtualAccount/page',
    virtualAccountDeduction:'/deyt/fund/virtualAccount/deduction',
    virtualAccountTransfer:'/deyt/fund/virtualAccount/transfer',
    virtualAccountLinePage:'/deyt/fund/virtualAccountLine/page',
    virtualAccountLineDetail:'/deyt/fund/virtualAccountLine/detail',
    virtualAccountLineInvalid:'/deyt/fund/virtualAccountLine/invalid',
    virtualAccountLineSave:'/deyt/fund/virtualAccountLine/save',
    virtualAccountLineUpdate:'/deyt/fund/virtualAccountLine/update',
  },
  /*资金管理 结束*/
  /*应收应付开始*/
  finance:{
    ledgerPageList:'/deyt/finance/ledger/pageList',
    purchasePageList:'/deyt/buy/documents/standingBookPage',//采购台账
    ledgerDetail:'/deyt/finance/ledger/detail',
    ledgerSaleExport:'/deyt/finance/ledger/saleExport',
    ledgerBuyExport:'/deyt/finance/ledger/buyExport',
    ledgertsExport:'/deyt/finance/ledger/tsExport',
    ledgerEstimateSaleDifft:'/deyt/finance/ledger/estimateSaleDiff',
    ledgerEstimateBuyDifft:'/deyt/finance/ledger/estimateBuyDiff',
    ledgerEstimateTsDifft:'/deyt/finance/ledger/estimateTsDiff',
    buyPayableFindListByCondition:'/deyt/finance/buyPayable/findListByCondition',
    tsPayableFindListByCondition:'/deyt/finance/tsPayable/findListByCondition',
    receiptTicketDetailList:'/deyt/finance/buyPayable/ticketDetail',
    saleReceivableFindListByCondition:'/deyt/finance/saleReceivable/findListByCondition',
    findSaleReceivableDetail:'/deyt/finance/saleReceivable/findSaleReceivableDetail',
    buyPayableExport:'/deyt/finance/buyPayable/buyPayableExport',
    tsPayableExport:'/deyt/finance/tsPayable/tsPayableExport',
    buyImageSummary:'/deyt/finance/buyImage/findSummaryListByCondition',
    buyImageExport:'/deyt/finance/buyImage/export',
    summaryExport:'/deyt/finance/buyImage/summaryExport',
    saleImage:'/deyt/finance/saleImage/findListByCondition',
    sellEstimate:'/finance/sellEstimate',
    sellEstimateListExport:'/deyt/finance/saleImage/listExport',
    reportFindListByCondition:'/deyt/finance/report/findListByCondition',
    saleReportFindSummaryListByCondition:'/deyt/finance/saleReport/findSummaryListByCondition',
    reportExport:'/deyt/finance/report/export',
    saleReportExport:'/deyt/finance/saleReport/export',
    saleReportFindListByIds:'/deyt/finance/saleReport/findListByIds',
    saleReportDetail:'/deyt/finance/saleReport/detail',
    saleReportDetailExport:'/deyt/finance/saleReport/detailExport',
    cancelClosing:'/deyt/finance/closing/cancelClosing',
    closingCheck:'/deyt/finance/closing/check',
    checkDetailRes:'/deyt/finance/closing/checkDetailRes',
    closing:'/deyt/finance/closing/closing',
    closingExtPage:'/deyt/finance/closing/extPage',
    estimateSaleDiffExport:'/deyt/finance/ledger/estimateSaleDiffExport',
    estimateBuyDiffExport:'/deyt/finance/ledger/estimateBuyDiffExport',
    estimateTsDiffExport:'/deyt/finance/ledger/estimateTsDiffExport',
    detailExport:'/deyt/finance/saleImage/detailExport',
    addedValueTaxSave:'/finance/addedValueTax/save',
    addedValueTaxPage:'/finance/addedValueTax/Page',
    saleReceivableExport:'/deyt/finance/saleReceivable/saleReceivableExport',
    listTicketTax:'/deyt/finance/ticket/listTicketTax',
    saveBookkeeping:'/deyt/finance/ticket/saveBookkeeping',
    pagePreInvoiceBuyBill:'/deyt/finance/invoice/pagePreInvoiceBuyBill',
    pagePreInvoiceTsBill:'/deyt/finance/invoice/pagePreInvoiceTsBill',
    nonInvoiceDetail:'/deyt/finance/invoice/nonInvoiceDetail',
    listCustMerchantByStatement:'/deyt/finance/invoice/listCustMerchantByStatement',
    invoiceSave:'/deyt/finance/invoice/save',
    invoiceUpdate:'/deyt/finance/invoice/update',
    invoiceDetail:'/deyt/finance/invoice/detail',
    invoiceInvalid:'/deyt/finance/invoice/invalid',
    generateSellEstimate:'/deyt/finance/saleImage/generateSellEstimate',
    generateBuyEstimate:'/deyt/finance/buyImage/generateBuyEstimate',
    generateTsEstimate:'/deyt/finance/tsImage/generateTsEstimate',
  },
  /*应收应付结束*/
  /*2021年目标分析计划 start */
  target:{
    annualPlanSave:'/deyt/base/tmp/annualPlan/save',//录入
    annualPlanGet:'/deyt/base/tmp/annualPlan/get',//详情
  },
  /*2021年目标分析计划 end */
  /*钢瓶管理 start */
  cylinder:{
    cylinderRecordPage:'/deyt/cylinder/container/record/page',//集装格扫描记录
    cylinderTagPage:'/deyt/cylinder/tag/page',//射频标签列表
    tagPage:'/deyt/cylinder/tag/page',//射频标签 - 列表
    tagSave:'/deyt/cylinder/tag/save',//射频标签 - 新增
    tagUpdate:'/deyt/cylinder/tag/update',//射频标签 - 编辑
    tagDetail:'/deyt/cylinder/tag/detail',//射频标签 - 详情
    tagDelete:'/deyt/cylinder/tag/delete',//射频标签 - 删除
    tagInstall:'/deyt/cylinder/tag/install',//射频标签 - 安装
    tagUnInstall:'/deyt/cylinder/tag/uninstall',//射频标签 - 解除安装
    truckList:'/deyt/cylinder/truck/list',//车辆列表
    truckRecordPage:'/deyt/cylinder/truck/record/page',//车辆扫描记录
    containerPage:'/deyt/cylinder/container/page',//集装格 - 分页列表
    containerList:'/deyt/cylinder/container/list',//集装格 - 列表
    containerSave:'/deyt/cylinder/container/save',//集装格 - 新增
    containerUpdate:'/deyt/cylinder/container/update',//集装格 - 编辑
    containerDetail:'/deyt/cylinder/container/detail',//集装格 - 详情
    containerDelete:'/deyt/cylinder/container/delete',//集装格 - 删除
    containerBind:'/deyt/cylinder/container/bind',//集装格 - 绑定
    tagList:'/deyt/cylinder/tag/list',//标签列表
    cylinderPage:'/deyt/cylinder/cylinder/page',//钢瓶 - 列表
    cylinderList:'/deyt/cylinder/cylinder/list',//钢瓶 - 列表
    cylinderSave:'/deyt/cylinder/cylinder/save',//钢瓶 - 新增
    cylinderUpdate:'/deyt/cylinder/cylinder/update',//钢瓶 - 编辑
    cylinderDetail:'/deyt/cylinder/cylinder/detail',//钢瓶 - 详情
    cylinderDelete:'/deyt/cylinder/cylinder/delete',//钢瓶 - 删除




  },
  /*钢瓶管理 end */

  /*充装*/
  charge: {
    chargeDict:'/deyt/charge/dict/',//字典
    adornmentMonadPage:'/deyt/charge/charge/adornmentMonad/page', // 充装单列表
    adornmentMonadSave:'/deyt/charge/charge/adornmentMonad/save', // 充装单新增
    adornmentMonadUpdate:'/deyt/charge/charge/adornmentMonad/update', // 充装单修改
    adornmentMonadDetail:'/deyt/charge/charge/adornmentMonad/detail', // 充装单详情
    adornmentMonadInvalid:'/deyt/charge/charge/adornmentMonad/invalid', // 充装单作废
    adornmentMonadExport:'/deyt/charge/charge/adornmentMonad/export', // 充装单导出
    adornmentMonadSiteUseList:'/deyt/charge/charge/adornmentMonad/siteUseList', // 获取充装单站点信息
    adornmentMonadContainerList:'/deyt/charge/charge/adornmentMonad/containerList', // 根据规格查询集装格结果
    adornmentMonadCheckPage:'/deyt/charge/charge/adornmentMonadCheck/page', // 充装单核对分页
    adornmentMonadCheckDetail:'/deyt/charge/charge/adornmentMonadCheck/detail', // 查询充装单
    adornmentMonadCheckCheck:'/deyt/charge/charge/adornmentMonadCheck/check', // 充装单核对
    adornmentMonadCheckExport:'/deyt/charge/charge/adornmentMonadCheck/export', // 充装单核对导出
  },

  /*统计 start */
  census: {
    censusDict:'/deyt/census/dict/',//字典
    financeReceivableFundWeekStatisticExport:'/deyt/census/census/financeReceivableFundWeekStatistic/export',//周统计导出
    financeReceivableFundWeekStatisticPage:'/deyt/census/census/financeReceivableFundWeekStatistic/page',//统计列表
    financeReceivableFundWeekStatisticDetail:'/deyt/census/census/financeReceivableFundWeekStatistic/detail',//查询应收账款周统计表
    StatisticListRemark:'/deyt/census/census/financeReceivableFundWeekStatistic/listRemark',//应收账款周统计备注表列表
    StatisticListSaveRemark:'/deyt/census/census/financeReceivableFundWeekStatistic/saveRemark',//新增应收账款周统计备注表
    financeReceivableFundWeekStatisticListCompanyList:'/deyt/census/census/financeReceivableFundWeekStatistic/companyList',//获取经营主体
  },
  /*统计 end */
  /*报表（cng+lng）start*/

  reportManage: {
    reportCngList:'/deyt/census/reportCng/list',//CNG列表
    reportCngDetail:'/deyt/census/reportCng/detail',//CNG详情
    reportCngUpdate:'/deyt/census/reportCng/update',//CNG编辑
    reportLngList:'/deyt/census/reportLng/list',//LNG列表
    reportLngUpdate:'/deyt/census/reportLng/update',//LNG编辑

  },
  /*报表（cng+lng）end*/
  /*流转业务 start */
  business: {
    flowDocumentAddPage:'/deyt/business/business/flow/documentAddPage',//新增采购单列表数据
    flowDecomposeListOrder:'/deyt/business/business/flow/decomposeListOrder',//查询lng业务流转表
    flowDetailListExt:'/deyt/business/business/flow/detailListExt',//下一步获取预览信息
    flowSave:'/deyt/business/business/flow/save',//新增lng业务流转表
    flowUpdate:'/deyt/business/business/flow/update',//修改lng业务流转表
    flowPage:'/deyt/business/business/flow/page',//lng业务流转表分页
    flowDetail:'/deyt/business/business/flow/detail',//查询lng业务流转表
    flowCashFlow:'/deyt/business/business/flow/cashFlow',//编辑获取流转信息
    flowDingBack:'/deyt/business/business/flow/dingBack',//批量审批
    flowCancel:'/deyt/business/business/flow/cancel',//取消
    businessDict:'/deyt/business/dict/',//字典

    nonStandardList:'/deyt/business/business/nonStandard/page',//非标列表
    nonStandardSave:'/deyt/business/business/nonStandard/save',//非标新增
    nonStandardUpdate:'/deyt/business/business/nonStandard/update',//非标修改
    nonStandardDetail:'/deyt/business/business/nonStandard/detail',//非标详情
    nonStandardDelete:'/deyt/business/business/nonStandard/delete',//非标删除
    nonStandardPreview:'/deyt/business/business/nonStandard/preview',//非标预览
    nonStandardSubmitStandard:'/deyt/business/business/nonStandard/submitStandard',//非标提交
    nonStandardIsInvalid:'/deyt/business/business/nonStandard/isInvalid',//非标作废
  },
  /*流转业务 end */
  /*报销单管理 start*/
  reimburse:{
    reimburseDict:'/deyt/cost/pub/dict',//字典项
    reimburseOrderPage:'/deyt/cost/reimburseOrder/page',//报销单分页
    reimburseOrderDelete:'/deyt/cost/reimburseOrder/delete',// 报销单删除
    reimburseOrderApprove:'/deyt/cost/reimburseOrder/approve',// 报销单审批
    reimburseOrderCheck:'/deyt/cost/reimburseOrder/check',// 报销单核对
    reimburseOrderDetail:'/deyt/cost/reimburseOrder/detail',// 报销单详情
    reimburseOrderInvalid:'/deyt/cost/reimburseOrder/invalid',// 报销单作废
    reimburseOrderList:'/deyt/cost/reimburseOrder/list',// 报销单列表
    reimburseOrderSave:'/deyt/cost/reimburseOrder/save',// 报销单新建
    reimburseOrderUpdate:'/deyt/cost/reimburseOrder/update',// 报销单更新
    getStaff:'/deyt/cost/pub/staff',//获取报销人接口
    getReimburseType:'/deyt/cost/reimburseType/list',//获取报销类型列表
    reimburseCollectApprove:'/deyt/cost/reimburseCollect/approve',//报销汇总审批
    reimburseCollectCheck:'/deyt/cost/reimburseCollect/check',//报销汇总核对
    reimburseCollectDetail:'/deyt/cost/reimburseCollect/detail',//报销汇总详情
    reimburseCollectEdit:'/deyt/cost/reimburseCollect/edit',//报销汇总编辑
    reimburseCollectExport:'/deyt/cost/reimburseCollect/export/detail',//报销汇总导出
    reimburseCollectInvalid:'/deyt/cost/reimburseCollect/invalid',//报销汇总作废
    reimburseCollectPage:'/deyt/cost/reimburseCollect/page',//报销汇总分页
    reimburseCollectPush:'/deyt/cost/reimburseCollect/push',//报销汇总推送付款
    reimburseCollectSave:'/deyt/cost/reimburseCollect/save',//报销汇总新增
    reimburseCollectUpdate:'/deyt/cost/reimburseCollect/update',//报销汇总更新
    reimburseTypeState:'/deyt/cost/reimburseType/alter/state',//报销类型更改状态
    reimburseTypeList:'/deyt/cost/reimburseType/list',//报销类型列表
    reimburseTypePage:'/deyt/cost/reimburseType/page',//报销类型分页
    reimburseTypeSave:'/deyt/cost/reimburseType/save',//报销类型新建
    reimburseTypeUpdate:'/deyt/cost/reimburseType/update',//报销类型更新
    reimburseStaffPage:'/deyt/cost/reimburseOrder/staff/page',//报销单填报
    reimburseStatistic:'/deyt/cost/reimburseOrder/statistic',//报销单统计
    reimburseMergeFile:'/deyt/cost/reimburseOrder/merge/file',//合并附件
  },
  /*报销单管理 end*/
  /*气款管理 start*/
  gasManagement:{
    pubDict:'/deyt/cost/pub/dict',//字典项
    pubCompany:'/deyt/cost/pub/company',//供气方下拉选
    gasApplyApprove:'/deyt/cost/gasApply/approve',//气款申请单审批
    gasApplyDetail:'/deyt/cost/gasApply/detail',//气款申请单详情
    gasApplyInvalid:'/deyt/cost/gasApply/invalid',//气款申请单作废
    gasApplyPage:'/deyt/cost/gasApply/page',//气款申请单分页
    gasApplySave:'/deyt/cost/gasApply/save',//气款申请单新建
    gasApplyUpdate:'/deyt/cost/gasApply/update',//气款申请单更新
    gasApplyPush:'/deyt/cost/gasApply/push',//推送付款
    gasApplyLast:'/deyt/cost/gasApply/last',//上一次采购信息

    budgetInvalid:'/deyt/cost/budget/invalid',//预算表作废
    budgetPage:'/deyt/cost/budget/page',//预算表分页
    budgetSave:'/deyt/cost/budget/save',//预算表新增
    budgetUpdate:'/deyt/cost/budget/update',//预算表更新
    budgetDetail:'/deyt/cost/budget/detail',//预算表详情
    budgetAdjust:'/deyt/cost/budget/adjust',//预算表调整
  },
  /*气款管理 end*/


  /*工资管理 start*/
  salaryManagement:{
    salarySpecialDeductionList:'/deyt/cost/salarySpecialDeduction/list',//个人所得税专项扣除列表
    salaryTaxLevelList:'/deyt/cost/salaryTaxLevel/list',//个税等级列表
    stationList:'/deyt/cost/station/list',//岗位下拉列表
    staffList:'/deyt/cost/salaryStaff/list',//人员
    dict:'/deyt/cost/pub/dict',//选项字典
    staffAccount:'/deyt/cost/pub/staff/account',//根据人员查账户

    salaryStaffDetail:'/deyt/cost/salaryStaff/detail',//人员工资信息详情
    salaryStaffPage:'/deyt/cost/salaryStaff/page',//人员工资信息分页
    salaryStaffSave:'/deyt/cost/salaryStaff/save',//人员工资信息新增
    salaryStaffState:'/deyt/cost/salaryStaff/state',//人员工资信息启用-停用
    salaryStaffUpdate:'/deyt/cost/salaryStaff/update',//人员工资信息更新
    getSpecialDeduction:'/deyt/cost/salaryStaff/getSpecialDeduction',//查询专项扣除
    updateSpecialDeduction:'/deyt/cost/salaryStaff/updateSpecialDeduction',//更新专项扣除

    salaryFloatingApprove:'/deyt/cost/salaryFloating/approve',//浮动工资审批
    salaryFloatingDetail:'/deyt/cost/salaryFloating/detail',//浮动工资详情
    salaryFloatingPage:'/deyt/cost/salaryFloating/page',//浮动工资分页
    salaryFloatingSave:'/deyt/cost/salaryFloating/save',//浮动工资新增
    salaryFloatingInvalid:'/deyt/cost/salaryFloating/invalid',//浮动工资作废
    salaryFloatingUpdate:'/deyt/cost/salaryFloating/update',//浮动工资更新
    salaryFloatingCopy:' /deyt/cost/salaryFloating/copyDetail',//浮动工资复制
    salaryFloatingImport:' /deyt/cost/salaryFloating/import',//浮动工资导入

    salaryFloatingTypeState:'/deyt/cost/salaryFloatingType/state',//浮动工资类型启用-停用
    salaryFloatingTypeDetail:'/deyt/cost/salaryFloatingType/detail',//浮动工资类型详情
    salaryFloatingTypePage:'/deyt/cost/salaryFloatingType/page',//浮动工资类型分页
    salaryFloatingTypeSave:'/deyt/cost/salaryFloatingType/save',//浮动工资类型新增
    salaryFloatingTypeInvalid:'/deyt/cost/salaryFloatingType/invalid',//浮动工资类型作废
    salaryFloatingTypeUpdate:'/deyt/cost/salaryFloatingType/update',//浮动工资类型更新
    salaryFloatingTypeList:'/deyt/cost/salaryFloatingType/list',//浮动工资类型列表-下拉选

    salarySocialSecurityApprove:'/deyt/cost/salarySocialSecurity/approve',//社保信息审批
    salarySocialSecurityDetail:'/deyt/cost/salarySocialSecurity/detail',//社保信息详情
    salarySocialSecurityPage:'/deyt/cost/salarySocialSecurity/page',//社保信息分页
    salarySocialSecuritySave:'/deyt/cost/salarySocialSecurity/save',//社保信息新增
    salarySocialSecurityInvalid:'/deyt/cost/salarySocialSecurity/invalid',//社保信息作废
    salarySocialSecurityUpdate:'/deyt/cost/salarySocialSecurity/update',//社保信息更新
    salarySocialSecurityList:'/deyt/cost/salarySocialSecurity/list',//社保信息列表-下拉选

    salaryExport:'/deyt/cost/salary/export',//工资明细导出
    salaryDetail:'/deyt/cost/salary/detail',//工资明细详情
    salaryPage:'/deyt/cost/salary/page',//工资明细分页
    salaryInvalid:'/deyt/cost/salary/invalid',//工资明细作废
    salaryCheck:'/deyt/cost/salary/check',//工资明细核对
    salaryGenerate:'/deyt/cost/salary/update',//生成工资数据
    salaryOneList:'/deyt/cost/salary/list',//一键核对列表
    salaryOneClickCheck:'/deyt/cost/salary/oneClickCheck',//一键核对

    salaryAdjustmentState:'/deyt/cost/salaryAdjustment/state',//工资调差启用-停用
    salaryAdjustmentDetail:'/deyt/cost/salaryAdjustment/detail',//工资调差详情
    salaryAdjustmentPage:'/deyt/cost/salaryAdjustment/page',//工资调差分页
    salaryAdjustmentSave:'/deyt/cost/salaryAdjustment/save',//工资调差新增
    salaryAdjustmentInvalid:'/deyt/cost/salaryAdjustment/invalid',//工资调差作废
    salaryAdjustmentUpdate:'/deyt/cost/salaryAdjustment/update',//工资调差更新
    salaryAdjustmentCopy:'/deyt/cost/salaryAdjustment/copyDetail',//工资调差复制

    salaryCollectApprove:'/deyt/cost/salaryCollect/approve',//工资汇总审批
    salaryCollectDetail:'/deyt/cost/salaryCollect/detail',//工资汇总详情
    salaryCollectPage:'/deyt/cost/salaryCollect/page',//工资汇总分页
    salaryCollectCollect:'/deyt/cost/salaryCollect/collect',//工资汇总汇总
    salaryCollectInvalid:'/deyt/cost/salaryCollect/invalid',//工资汇总作废
    salaryCollectCheck:'/deyt/cost/salaryCollect/check',//工资汇总核对
    salaryCollectPay:'/deyt/cost/salaryCollect/pay',//生成付款申请单

    salaryStaffAttendanceConfirm:'/deyt/cost/salaryStaffAttendance/confirm',//考勤确认
    salaryStaffAttendanceImport:'/deyt/cost/salaryStaffAttendance/import',//考勤导入
    salaryStaffAttendanceInvalid:'/deyt/cost/salaryStaffAttendance/invalid',//考勤作废
    salaryStaffAttendancePage:'/deyt/cost/salaryStaffAttendance/page',//考勤分页
    salaryStaffAttendanceExport:'/deyt/cost/salaryStaffAttendance/template/export',//下载模板
    salaryStaffAttendanceUpdate:'/deyt/cost/salaryStaffAttendance/update',//考勤更新

  },
  /*工资管理 end*/
  /*新绩效考核 start*/
  performance:{
    kpiGradeDetail:'/deyt/cost/kpiGrade/detail',// 等级配置详情
    kpiGradeInvalid:'/deyt/cost/kpiGrade/invalid',// 等级配置作废
    kpiGradeList:'/deyt/cost/kpiGrade/list',// 等级配置列表
    kpiGradeSave:'/deyt/cost/kpiGrade/save',// 等级配置新建
    kpiGradeUpdate:'/deyt/cost/kpiGrade/update',// 等级配置更新
    kpiGradeEffect:'/deyt/cost/kpiGrade/effect/mark',// 最新生效中的等级

    kpiCoefficientDetail:'/deyt/cost/kpiCoefficient/detail',// 考核系数详情
    kpiCoefficientInvalid:'/deyt/cost/kpiCoefficient/invalid',// 考核系数作废
    kpiCoefficientList:'/deyt/cost/kpiCoefficient/list',// 考核系数列表
    kpiCoefficientSave:'/deyt/cost/kpiCoefficient/save',// 考核系数新建
    kpiCoefficientUpdate:'/deyt/cost/kpiCoefficient/update',// 考核系数更新
    kpiCoefficientEffect:'/deyt/cost/kpiCoefficient/effect/coefficient',// 生效考核系数

    kpiItemDetail:'/deyt/cost/kpiItem/detail',// 考核项目详情
    kpiItemInvalid:'/deyt/cost/kpiItem/invalid',// 考核项目作废
    kpiItemPage:'/deyt/cost/kpiItem/page',// 考核项目列表
    kpiItemSave:'/deyt/cost/kpiItem/save',// 考核项目新建
    kpiItemUpdate:'/deyt/cost/kpiItem/update',// 考核项目更新
    kpiItemList:'/deyt/cost/kpiItem/option/list',// 下拉选-列表

    kpiRoleList:'/deyt/cost/kpiRole/option/list',// 角色下拉选
    kpiRoleItem:'/deyt/cost/kpiRole/item',// 考核项
    kpiRoleItemSave:'/deyt/cost/kpiRole/item/save',// 考核项保存
    kpiRoleItemCopy:'/deyt/cost/kpiRole/copy/item',// 复制考核项
    kpiRoleInvalid:'/deyt/cost/kpiRole/invalid',// 考核角色作废
    kpiRolePage:'/deyt/cost/kpiRole/page',// 考核角色列表
    kpiRoleSave:'/deyt/cost/kpiRole/save',// 考核角色新建
    kpiRoleUpdate:'/deyt/cost/kpiRole/update',// 考核角色更新
    kpiRoleState:'/deyt/cost/kpiRole/state/change',// 启用、停用

    kpiStaffCope:'/deyt/cost/kpiStaff/copy',// 考核对象复制
    kpiStaffSave:'/deyt/cost/kpiStaff/save',// 考核对象新建/保存
    kpiStaffDetail:'/deyt/cost/kpiStaff/detail',// 考核对象详情
    kpiStaffPage:'/deyt/cost/kpiStaff/page',// 考核对象分页
    kpiStaffState:'/deyt/cost/kpiStaff/state/change',// 启用、停用
    kpiStaffList:'/deyt/cost/kpiStaff/option/list',// 考核对象下拉选
    assessStaffList:'/deyt/cost/kpiStaff/assessStaff/list',// 考核人列表
    assessStaffSet:'/deyt/cost/kpiStaff/assessStaff/set',// 考核人新建编辑

    kpiStaffCompleteList:'/deyt/cost/kpiStaffComplete/list',// 考核人员完成额列表
    kpiStaffCompleteSave:'/deyt/cost/kpiStaffComplete/save',// 考核人员完成额新建
    kpiStaffCompleteCheck:'/deyt/cost/kpiStaffComplete/check',// 考核人员完成额核对
    kpiStaffCompleteImport:'/deyt/cost/kpiStaffComplete/import',// 考核人员完成额导入

    kpiAssessConfirm:'/deyt/cost/kpiAssess/confirm',// 考核表确认
    kpiAssessDetail:'/deyt/cost/kpiAssess/detail',// 考核表详情
    kpiAssessExport:'/deyt/cost/kpiAssess/export',// 考核表导出
    kpiAssessInvalid:'/deyt/cost/kpiAssess/invalid',// 考核表作废
    kpiAssessPage:'/deyt/cost/kpiAssess/page',// 考核表分页
    kpiAssessUpdate:'/deyt/cost/kpiAssess/update',// 考核表一键更新
    kpiAssessUpdateItem:'/deyt/cost/kpiAssess/updateItem',// 更新考核项
    kpiStaff:'/deyt/cost/kpiStaff/option/list',// 人员下拉选
    kpiMark:'/deyt/cost/kpiAssess/mark',// 考核分数
    kpiScoreGrade:'/deyt/cost/kpiScoreGrade/list',// 评分等级
    kpiAssessRevoke:'/deyt/cost/kpiAssess/revoke',// 考核表撤回
    kpiAssessRevokeLastStep:'/deyt/cost/kpiAssess/revokeLastStep',// 考核表撤回上一级

    kpiYearAssessConfirm:'/deyt/cost/kpiYearAssess/confirm',// 年度考核表确认
    kpiYearAssessDetail:'/deyt/cost/kpiYearAssess/detail',// 年度考核表详情
    kpiYearAssessExport:'/deyt/cost/kpiYearAssess/export',// 年度考核表导出
    kpiYearAssessInvalid:'/deyt/cost/kpiYearAssess/invalid',// 年度考核表作废
    kpiYearAssessPage:'/deyt/cost/kpiYearAssess/page',// 年度考核表分页
    kpiYearAssessUpdate:'/deyt/cost/kpiYearAssess/update',// 年度考核表一键更新
    kpiYearAssessUpdateItem:'/deyt/cost/kpiYearAssess/updateItem',// 更新考核项
    kpiYearAssessMark:'/deyt/cost/kpiYearAssess/mark',// 打分信息
    kpiAssessComment:'/deyt/cost/kpiScoreGrade/comment/list',// 评语列表
    kpiYearAssessRevoke:'/deyt/cost/kpiYearAssess/revoke',// 年度考核表撤回

    kpiAssessReportMonth:'/deyt/cost/kpiAssessReport/month',// 月度报表
    kpiAssessReportScore:'/deyt/cost/kpiAssessReport/score',// 分数柱状图
    kpiAssessReportYear:'/deyt/cost/kpiAssessReport/year',// 年度报表
    kpiAssessReportTop:'/deyt/cost/kpiAssessReport/top',// 年度报表

  },
  /*新绩效考核 end*/
};

export default api;



// WEBPACK FOOTER //
// ./src/ajax/api.js